<template>
    <div class="card-designer">
        <div class="view-box" :class="{ 'hide-boxes': hideBoxes }">
            <div class="label" style="position: absolute;right: 5px;width:85px">
                <p class="btn sm" style="width: 80px;" @click="startPreview()" >preview</p>
            </div>
            <div class="faces-box">
                <div class="label">
                    <p>Font Family</p>
                    <div class="font-select" style="width: 394px;position: relative;">
                        <div @click="showFontInput($event)">
                            <input class="font-select-input" style="font-size: 20px;margin:5px 0px 5px 0px;width:100%" @keyup="filterFonts('keyup',$event)" @keydown="filterFonts('keydown',$event)" @focus="startShowFocus($event)" @blur="stopShowFontSearch()" />
                            <img v-if="selectedFontFamily" :src="selectedFontFamily.src" style="margin:px 0px 5px 0px;padding:0px;position: absolute;top:0px;left:0px;border:1px solid black;background-color: white;padding-bottom:3px;padding-right:3px"  />
                        </div>

                        <div style="border:1px solid #c0c0c0;position: absolute;top:33px;left:0px;width: 400px;max-height: calc(100vh - 147px);overflow-y: scroll;" v-if="showFontSearch">
                            <div v-for="(font,i) in fontFamilies.filter(f => f.selected)" :key="i" style="border-bottom: 1px solid #c0c0c0;background-color: white;z-index:150;position: relative;">
                                <img :src="font.src" loading="lazy" :id="font._id" style="background-color: white" @click="selectFontFamily(font,$event)"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="app-page-container">
                    
                    <div class="app-nav">
                        <p v-for="field in appNav" @click="appNavSelected = field.title" :class="{ selected: appNavSelected == field.title }">{{ field.title }}</p>
                    </div>
                    <div v-if="appNavSelected == 'Pages'">
                        <p class="app-pages-draft">DRAFT PAGES</p>
                        <div class="app-pages sub-0" v-for="(appPage,i) in (appPages.draft || [])" :key="appPage.page._id">
                            <p class="app-page-title" :class="{ selected: appPage.selected }" @click="selectAppPage(appPage,$event)">{{ appPage.page.title }}</p>                     
                            <div class="sub-1" v-for="(appPage,j) in appPage.subs" :key="'sub-1-'+j">
                                <p class="app-page-title" :class="{ selected: appPage.selected }" @click="selectAppPage(appPage,$event)">{{ appPage.page.title }}</p>
                                <div class="sub-2" v-for="(appPage,k) in appPage.subs" :key="'sub-2-'+k">
                                    <p class="app-page-title" :class="{ selected: appPage.selected }" @click="selectAppPage(appPage,$event)">{{ appPage.page.title }}</p>
                                    <div class="sub-3" v-for="(appPage,l) in appPage.subs" :key="'sub-3-'+l">
                                        <p class="app-page-title" :class="{ selected: appPage.selected }" @click="selectAppPage(appPage,$event)">{{ appPage.page.title }}</p>
                                        <div class="sub-4" v-for="(appPage,m) in appPage.subs" :key="'sub-4-'+m">
                                            <p class="app-page-title" :class="{ selected: appPage.selected }" @click="selectAppPage(appPage,$event)">{{ appPage.page.title }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p class="app-pages-draft" style="margin-top: 50px;">LIVE PAGES</p>
                        <div class="app-pages sub-0" v-for="(appPage,i) in (appPages.live || [])" :key="appPage.page._id">
                            <p class="app-page-title" :class="{ selected: appPage.selected }" @click="selectAppPage(appPage)">{{ appPage.page.title }}</p>
                            <div class="sub-1" v-for="appPage in appPage.subs" :key="appPage.page._id">
                                <p class="app-page-title" :class="{ selected: appPage.selected }" @click="selectAppPage(appPage)">{{ appPage.page.title }}</p>
                                <div class="sub-2" v-for="(appPage,k) in appPage.subs" :key="appPage.page._id">
                                    <p class="app-page-title" :class="{ selected: appPage.selected }" @click="selectAppPage(appPage)">{{ appPage.page.title }}</p>
                                    <div class="sub-3" v-for="(appPage,l) in appPage.subs" :key="appPage.page._id">
                                        <p class="app-page-title" :class="{ selected: appPage.selected }" @click="selectAppPage(appPage)">{{ appPage.page.title }}</p>
                                        <div class="sub-4" v-for="(appPage,m) in appPage.subs" :key="appPage.page._id">
                                            <p class="app-page-title" :class="{ selected: appPage.selected }" @click="selectAppPage(appPage)">{{ appPage.page.title }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="appNavSelected == 'Cards'">
                        <p v-for="(card,i) in cards" :key="i" class="app-page-title" @click="selectCard(card,$event)" :class="{ selected: card.selected }">{{ card.title }}</p>
                    </div>
                    <div v-if="appNavSelected == 'Buttons'" class="app-nav-buttons">
                        <div class="app-nav-button" v-for="(type,i) in types" :key="i" @mousedown="addBtnDrag(type,$event)" @click="addBtn(type)">
                            <div class="app-nav-button-icon">

                            </div>
                            <p class="app-nav-button-title">{{ type.title }}</p>
                        </div>
                    </div>
                </div>
                <div style="display: none;" v-for="(face,i) in card.faces.filter(f => f.show)" :key="i">
                    <p class="face-box-face" @click="selectFace(face)" :style="{ fontWeight: face.selected ? 'bold' : '' }">{{ face.title }}</p>
                    <div v-for="(btn,y) in face.btns" :key="y">
                        <p class="face-box-type ellip" :class="'type-'+btn.type" @click="selectBtn(face,btn,$event)" :style="{ fontWeight: btn.selected ? 'bold' : '' }" v-html="['text','button'].indexOf(btn.type) == -1 ? btn.title : btn.value"></p>
                    </div>
                </div>
            </div>
            <div class="cards-box" @click="clearSelected($event)" @mousedown="startSelection($event)" :style="{ transform: 'scale('+transformScale+')' }">
                <div class="edit-card-box edit-stamps edit-headers" v-if="editAssets">
                    <div style="width: 435px;border:1px solid #c0c0c0;margin-top: 50px;position: relative;">
                        <header style="border-bottom: 0px"><p>Site Assets</p><div class="x" @click="editAssets = false"></div></header>
                        <div class="assets-box">
                            <div class="label">
                                <p>Site Title</p>
                                <input v-model="assets.siteTitle" style="width: calc(100% + 10px)" />
                            </div>
                            <div class="label" style="width: 100%;margin: 0px;">
                                <div class="label" style="width: 100px">
                                    <p>Site Brand Image</p>
                                    <div style="width:80px;float: left;border:1px solid #c0c0c0;display: grid;" :style="{ backgroundColor: assets.headerColor, minHeight: !assets.siteBrand ? '50px' : '' }" @click="addLoyaltyImage('siteBrand')">
                                        <img v-if="assets.siteBrand" :src="assets.siteBrand" width="100%" />
                                    </div>
                                </div>
                                <div class="label" style="width: 75px">
                                    <p>Height</p>
                                    <input id="headerHeight" v-model.number="assets.headerHeight" />
                                </div>
                                <div class="label" style="width: 75px;"> 
                                    <p>Padding</p>
                                    <input id="headerPadding" v-model.number="assets.headerPadding" />
                                </div>
                                <div class="label" style="width: 75px;"> 
                                    <p>Home Page</p>
                                    <input type="checkbox" v-model="assets.homeHeader" />
                                </div>
                            </div>
                            <div class="label">
                                <p>Page Header</p>
                                <div style="border:1px solid #c0c0c0;position: relative;width: 414px;" @click="addLoyaltyImage('siteBrand')" :style="{ backgroundColor: assets.headerColor, height: assets.headerHeight+'px' }">
                                    <div v-if="assets.siteBrand" style="width:100%;height:100%;display: flex;justify-content: space-around;align-items: center;" >
                                        <img :src="assets.siteBrand" :height="assets.headerHeight - ( 2 * assets.headerPadding)" :style="{ marginTop: assets.headerPadding+'px', marginBottom: assets.headerPadding+'px'  }" />
                                    </div>
                                    <h1 v-if="!assets.siteBrand" style="top:0px;left:0px;width:100%;line-height: 35px;text-align: center;" :style="{ color: client.fontColor }"></h1>
                                    <div v-if="assets.showBack" style="position: absolute;top:0px;left:0px">
                                        <svg :width="assets.headerHeight" height="assets.headerHeight" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
                                            <line :stroke="assets.headerAccentColor" transform="rotate(-45 75.50094604492188,50.25008773803711)" :stroke-linecap="assets.bevel ? 'round': 'square'" y2="50" x2="110" y1="50" x1="42" :stroke-width="assets.headerStrokeWidth"/>
                                            <line :stroke="assets.headerAccentColor" transform="rotate(45 74.75089263916017,98.50006866455077)" :stroke-linecap="assets.bevel ? 'round': 'square'" y2="98" x2="108" y1="98" x1="41" :stroke-width="assets.headerStrokeWidth"/>
                                       </svg>
                                    </div>
                                    <div v-if="assets.showAvatar" style="position: absolute;top:0px;right:0px">
                                        <svg :width="assets.headerHeight" :height="assets.headerHeight" viewBox="0 0 190 190" xmlns="http://www.w3.org/2000/svg">
                                            <defs>
                                             <clipPath id="clip1">
                                              <path d="m20.875,20.875l145.5,0l0,145.5l-145.5,0l0,-145.5zm0,0"/>
                                             </clipPath>
                                            </defs>
                                              <g clip-path="url(#clip1)" clip-rule="nonzero">
                                               <path :fill="assets.headerAccentColor" fill-rule="nonzero"  :stroke-width="assets.headerStrokeWidth" :stroke="assets.headerAccentColor" d="m93.625,20.875c-40.12891,0 -72.75,32.62109 -72.75,72.75c0,40.125 32.62109,72.75 72.75,72.75c40.125,0 72.75,-32.625 72.75,-72.75c0,-40.12891 -32.625,-72.75 -72.75,-72.75zm0,142.88672c-38.67187,0 -70.13672,-31.46875 -70.13672,-70.13672c0,-38.67187 31.46485,-70.13672 70.13672,-70.13672c38.66797,0 70.13672,31.46485 70.13672,70.13672c0,38.66797 -31.46875,70.13672 -70.13672,70.13672zm15.15234,-70.54688c5.75,-4.55468 9.48047,-11.60937 9.48047,-19.48437c0,-13.69922 -11.12109,-24.82422 -24.82031,-24.82422c-13.69922,0 -24.82422,11.125 -24.82422,24.82422c0,7.91016 3.69531,14.92969 9.48438,19.48437c-5.89844,2.23829 -11.16407,6.19532 -15.00782,11.3086c-4.36718,5.85937 -6.67968,12.76562 -6.67968,20.04297c0,1.19531 0.07422,2.42968 0.1875,3.66015c0.07422,0.67188 0.63281,1.15625 1.30468,1.15625l71.10938,0c0.67187,0 1.23047,-0.48437 1.30469,-1.15625c0.14843,-1.23047 0.1875,-2.42578 0.1875,-3.66015c0,-7.23828 -2.31641,-14.1836 -6.64453,-20.00391c-3.84375,-5.11719 -9.14454,-9.07031 -15.08204,-11.34766zm-37.55078,-19.48437c0,-12.24609 9.96875,-22.21094 22.21094,-22.21094c12.24219,0 22.21094,9.96485 22.21094,22.21094c0,12.24219 -9.96875,22.20703 -22.21094,22.20703c-12.24219,0 -22.21094,-9.96484 -22.21094,-22.20703zm56.55078,53.03906l-68.67968,0c-0.03907,-0.74609 -0.07422,-1.45312 -0.07422,-2.20312c0,-6.71875 2.125,-13.10157 6.15625,-18.47657c3.88281,-5.14843 9.33203,-9.07031 15.41797,-11.01171l0.1875,0c3.69531,2.20312 8.02343,3.47265 12.65234,3.47265c4.62891,0 8.99609,-1.26953 12.69141,-3.50781c0,0 0.03515,0 0.03515,0.03516c6.125,1.9414 11.64844,5.86328 15.53125,11.08593c4.03125,5.375 6.1211,11.75782 6.1211,18.44141c0.07422,0.71094 0.03515,1.41797 -0.03907,2.16406zm0,0" />
                                             </g>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="label" style="margin: 0px;width: 100%;">
                                <div class="label color" style="width: 124px;">
                                    <p>Header Colour</p>
                                    <div>
                                        <input type="color" v-model="assets.headerColor"/>
                                        <input v-model="assets.headerColor" />
                                    </div>
                                </div>
                                <div class="label color" style="width: 124px;">
                                    <p>Accent Colour</p>
                                    <div>
                                        <input type="color" v-model="assets.headerAccentColor"/>
                                        <input v-model="assets.headerAccentColor" />
                                    </div>
                                </div>
                                <div class="label" style="width: 100px;">
                                    <p>Line Width</p>
                                    <div>
                                        <input id="headerStrokeWidth" v-model.number="assets.headerStrokeWidth" style="width: calc(100% - 20px);padding: 2px;font-size: 20px;" />
                                    </div>
                                </div>
                            </div>
                            <div class="label" style="margin:0px;width:100%">
                                <div class="label" style="width:50px">
                                    <p>Back</p>
                                    <div style="border:1px solid #c0c0c0;position: relative;width: 50px;height: 50px;padding-right:5px" @click="addLoyaltyImage('headerPlain')" :style="{ backgroundColor: assets.headerColor }">
                                        <svg width="50" height="50" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
                                            <line :stroke="assets.headerAccentColor" transform="rotate(-45 75.50094604492188,50.25008773803711)" :stroke-linecap="assets.headerBackBevel ? 'round': 'square'" y2="50" x2="110" y1="50" x1="42" :stroke-width="assets.headerStrokeWidth"/>
                                            <line :stroke="assets.headerAccentColor" transform="rotate(45 74.75089263916017,98.50006866455077)" :stroke-linecap="assets.headerBackBevel ? 'round': 'square'" y2="98" x2="108" y1="98" x1="41" :stroke-width="assets.headerStrokeWidth"/>
                                       </svg>
                                    </div>
                                </div>
                                <div class="label" style="width: 40px;">
                                    <p>Show</p>
                                    <input v-model="assets.showBack" type="checkbox" />
                                </div>
                                <div class="label" style="width: 60px;">
                                    <p>Bevel</p>
                                    <input v-model="assets.headerBackBevel" type="checkbox" />
                                </div>
                                <div class="label" style="width:50px">
                                    <p>Avatar</p>
                                    <div style="border:1px solid #c0c0c0;position: relative;width: 50px;height: 50px;padding-right:5px":style="{ backgroundColor: assets.headerColor }">
                                        <svg width="50" height="50" viewBox="0 0 190 190" xmlns="http://www.w3.org/2000/svg">
                                            <defs>
                                             <clipPath id="clip1">
                                              <path d="m20.875,20.875l145.5,0l0,145.5l-145.5,0l0,-145.5zm0,0"/>
                                             </clipPath>
                                            </defs>
                                              <g clip-path="url(#clip1)" clip-rule="nonzero">
                                               <path :fill="assets.headerAccentColor" fill-rule="nonzero"  :stroke-width="assets.headerStrokeWidth" :stroke="assets.headerAccentColor" d="m93.625,20.875c-40.12891,0 -72.75,32.62109 -72.75,72.75c0,40.125 32.62109,72.75 72.75,72.75c40.125,0 72.75,-32.625 72.75,-72.75c0,-40.12891 -32.625,-72.75 -72.75,-72.75zm0,142.88672c-38.67187,0 -70.13672,-31.46875 -70.13672,-70.13672c0,-38.67187 31.46485,-70.13672 70.13672,-70.13672c38.66797,0 70.13672,31.46485 70.13672,70.13672c0,38.66797 -31.46875,70.13672 -70.13672,70.13672zm15.15234,-70.54688c5.75,-4.55468 9.48047,-11.60937 9.48047,-19.48437c0,-13.69922 -11.12109,-24.82422 -24.82031,-24.82422c-13.69922,0 -24.82422,11.125 -24.82422,24.82422c0,7.91016 3.69531,14.92969 9.48438,19.48437c-5.89844,2.23829 -11.16407,6.19532 -15.00782,11.3086c-4.36718,5.85937 -6.67968,12.76562 -6.67968,20.04297c0,1.19531 0.07422,2.42968 0.1875,3.66015c0.07422,0.67188 0.63281,1.15625 1.30468,1.15625l71.10938,0c0.67187,0 1.23047,-0.48437 1.30469,-1.15625c0.14843,-1.23047 0.1875,-2.42578 0.1875,-3.66015c0,-7.23828 -2.31641,-14.1836 -6.64453,-20.00391c-3.84375,-5.11719 -9.14454,-9.07031 -15.08204,-11.34766zm-37.55078,-19.48437c0,-12.24609 9.96875,-22.21094 22.21094,-22.21094c12.24219,0 22.21094,9.96485 22.21094,22.21094c0,12.24219 -9.96875,22.20703 -22.21094,22.20703c-12.24219,0 -22.21094,-9.96484 -22.21094,-22.20703zm56.55078,53.03906l-68.67968,0c-0.03907,-0.74609 -0.07422,-1.45312 -0.07422,-2.20312c0,-6.71875 2.125,-13.10157 6.15625,-18.47657c3.88281,-5.14843 9.33203,-9.07031 15.41797,-11.01171l0.1875,0c3.69531,2.20312 8.02343,3.47265 12.65234,3.47265c4.62891,0 8.99609,-1.26953 12.69141,-3.50781c0,0 0.03515,0 0.03515,0.03516c6.125,1.9414 11.64844,5.86328 15.53125,11.08593c4.03125,5.375 6.1211,11.75782 6.1211,18.44141c0.07422,0.71094 0.03515,1.41797 -0.03907,2.16406zm0,0" />
                                             </g>
                                        </svg>
                                    </div>
                                </div>
                                <div class="label" style="width: 40px;">
                                    <p>Show</p>
                                    <input v-model="assets.showAvatar" type="checkbox" />
                                </div>
                                <div class="label" style="width: 40px;">
                                    <p>Favicon</p>
                                    <div style="border:1px solid #c0c0c0;position: relative;width: 30px;height: 30px;background-color: whitesmoke;" @click="addLoyaltyImage('favicon')">
                                    </div>
                                </div>
                            </div>
                            <div class="label">
                                <p>Account Page</p>
                                <select v-model="client.acctPage_id"><option v-for="page in [{ title: 'Select Page' }].concat(pages)" :value="page._id">{{ page.title }}</option></select>
                            </div>
                        </div>
                        <div class="btns">
                            <p class="btn" @click="saveAssets()">save</p>
                        </div>
                    </div>                   
                </div>
                <div class="edit-card-box edit-stamps" v-if="editStamps">
                    <div style="width: 450px;border:1px solid #c0c0c0;margin-top: 100px;height:275px;position: relative;">
                        <header><p>Loyalty Stamps</p><div class="x" @click="editStamps = false"></div></header>
                        <div class="stamp-box">
                            <div style="border:1px solid #c0c0c0" @click="addLoyaltyImage('loyaltyPlain')" :style="{ backgroundColor: client.backgroundColor }">
                                <img v-if="card.loyaltyPlain" :src="card.loyaltyPlain" />
                            </div>
                            <div style="border:1px solid #c0c0c0" @click="addLoyaltyImage('loyaltyStamp')" :style="{ backgroundColor: client.backgroundColor }">
                                <img v-if="card.loyaltyStamp" :src="card.loyaltyStamp" />
                            </div>
                        </div>
                        <div class="stamp-title">
                            <p @click="addLoyaltyImage('loyaltyPlain')">Plain</p>
                            <p @click="addLoyaltyImage('loyaltyStamp')">Stamped</p>
                        </div>
                        <div class="btns">
                            <p class="btn" @click="editStamps = false">save</p>
                        </div>
                    </div>
                </div>
                <div  v-if="!editStamps && !editAssets" v-for="face in card.faces" class="card-container" :style="{ height: ((face.height || card.height)+32)+'px' }">
                    <div class="card-options" @click="selectFace(face)" >
                        <p style="float: left;margin: 0px 0px;">{{ face.face }}</p>
                        <!-- <p style="float: right;margin: 2px 0px;line-height:1.1;" class="btn sm" @click="eFace = eFace == face ? false : face" :style="{ opacity: eFace == face ? 1 : 0.5 }">select</p> -->
                        <div class="plus" @click="addFace(card)"></div>
                    </div>
                    <div class="edit-card-box" @click="selectFace(face)" :class="{ selected: face.selected }" :style="{ height: (face.height || card.height)+'px', backgroundColor: face.backgroundColor, color: face.fontColor }">
                        
                        <PageHeader v-if="face.face == 'page' || client.homeHeader" :client="client" :page="face" :showBack="face.face == 'page'" :showAvatar="face.face == 'home'" />
                        <!-- 
                        <div v-if="editPages" style="position: relative" class="home-header-plain">
                            <img :src="client.headerPlain" class="home-header-plain" width="100%" />
                            <div v-if="face.face == 'page'" style="position: absolute;top:0px;left:0px">
                                <svg width="77" height="77" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
                                    <line :stroke="client.backColor" transform="rotate(-45 75.50094604492188,50.25008773803711)" :stroke-linecap="client.bevel ? 'round': 'square'" y2="50" x2="110" y1="50" x1="42" :stroke-width="client.backWidth"/>
                                    <line :stroke="client.backColor" transform="rotate(45 74.75089263916017,98.50006866455077)" :stroke-linecap="client.bevel ? 'round': 'square'" y2="98" x2="108" y1="98" x1="41" :stroke-width="client.backWidth"/>
                                </svg>
                            </div>
                        </div>
                        -->
                        <div class="card-src" v-if="face.src" style="overflow: hidden;height: calc(100% - 77px);" :style="{ marginTop: ( ( face.face == 'page' || client.homeHeader )  ? client.headerHeight : 0)+'px' }">
                            <img :src="face.src" width="100%" />
                        </div>
                        <!-- <img class="card-src" v-if="face.src" :src="face.src" /> -->
                        <div class="card-btns" :style="{ marginTop: ( ( face.face == 'page' || client.homeHeader )  ? ( client.headerHeight || 0 ) : 0)+'px' }">
                            <div v-if="btn.component" class="card-btn" @dblclick="cropImage(face,btn)" @mousedown="startMove(face,btn,$event)" @click="selectBtn(face,btn,$event)" v-for="(btn,i) in face.btns" :key="i">
                                <component :is="btn.component" :btn="btn" class="ad-btn" :page="face" :class="{ selected: btn.selected }" :style="btn.style"></component>
                                <div v-if="btn.selected" style="width: 100%;height: 100%;">
                                    <div v-if="btn.cWidth" class="c-width"></div>
                                    <div v-if="btn.clWidth" class="cl-width"></div>
                                    <div v-if="btn.crWidth" class="cr-width"></div>
                                    <div v-if="btn.cHeight" class="c-height"></div>
                                    <EditBox :btn="btn" @setBtnValue="setBtnValue" />
                                </div>
                                
                            </div> 
                        </div>
                    </div>
                    <div @click="card.faces = card.faces.filter(f => f != face)" class="plus minus"></div>
                </div>                
            </div>
            <Quill v-if="quill" :item="quill" @emit="emitQuill" @exit="quill = false" />
            <div v-if="Card" class="fixed-scroller">
                <div style="display: flex;align-items: center;width: calc(100% - 380px);left: 0px;position:absolute;height: 100%;max-height: 800px;justify-content: space-around;">
                    <div style="width: 414px;padding: 10px 25px 10px 10px;position: relative;background-color: white;">
                        <div class="x fixed-scroller-x" style="right: -40px;top:-35px" @click="Card = false" ></div>
                        <Card :card="Card" style="overflow: hidden;background-color: white;" :noedit="true" />
                    </div>
                    
                </div>
                
            </div>
        </div>
        <div class="left-nav" style="display: none;">
            <div v-for="type in types" class="type-box" @click="addBtn(type)">
                <div class="type-icon">
                    <img v-if="type.icon" :src="type.icon" />
                </div>
                <p class="type-title">{{ type.title }}</p>
            </div>
        </div>
        <div class="top-nav">
            <div class="top-item" v-if="!editPages" style="display: none;">
                <p class="btn sm" v-if="faces.filter(f => f.show).length == 1" @click="addBack()">add back</p>
                <p class="btn sm" v-if="faces.filter(f => f.show).length == 2" @click="removeBack()">remove back</p>
            </div>
            <div class="top-item label">
                <p>height</p>
                <input v-model.number="card.height" style="width: 90px;"/>
            </div>
            <div class="top-item center label" style="width: 550px;">
                <p>{{ editPages ? 'Page Title' : 'Card Title' }}</p>
                <input v-model="card.title" style="width: 350px;"/>
            </div>
            <div class="top-item" style="width: 40px;height: 10px;float: right;">
                <div class="x" @click="confirmExit"></div>
            </div>
            <div class="top-item" style="float: right;" @click="save">
                <p class="btn sm">save</p>
            </div>
            <div class="top-item" style="float: right;" @click="copy">
                <p class="btn sm">copy</p>
            </div>
            <div class="top-item" style="float: right;" @click="preview">
                <p class="btn sm">preview</p>
            </div>
        </div>
        <div class="right-nav">
            <div v-if="eFace">
                <p class="field-title">{{ card.title }}</p>
                <div v-if="['front','home','page'].indexOf(eFace.face) == -1" class="cross" style="top:5px;right:15px" @click="removeFace(eFace)"></div>
                <div class="label" style="margin-left: 0px;margin-right: 0px;width: 100%;">
                    <div class="color-group">
                        <div class="color-box" id="client.backgroundColor" :style="{ backgroundColor: client.backgroundColor }">
                            <p>Background</p>
                            <input v-model="client.backgroundColor" type="color" />
                        </div>
                        <div class="color-box" id="client.fontColor" :style="{ backgroundColor: client.fontColor }">
                            <p>Font</p>
                            <input v-model="client.fontColor" type="color" />
                        </div>
                        <div class="color-box" id="client.btnColor" :style="{ backgroundColor: client.btnColor }">
                            <p>Button</p>
                            <input v-model="client.btnColor" type="color" />
                        </div>
                        <div class="color-box" id="client.btnFontColor" :style="{ backgroundColor: client.btnFontColor }">
                            <p>Button Font</p>
                            <input v-model="client.btnFontColor" type="color" />
                        </div>
                    </div>
                    <div class="quest" @click="colorQuest($event)"></div>
                </div>
                <div v-if="['home','page'].indexOf(eFace.face) > -1">
                    <p class="page-colors">This Page Colors</p>
                    <div class="label w-50 color">
                        <p>Background Color</p>
                        <input type="color" v-model="colors.backgroundColor" />
                        <input v-model="colors.backgroundColor" />
                    </div>
                    <div class="label w-50 color">
                        <p>Font Color</p>
                        <input id="fontColor" type="color" v-model="colors.fontColor"/>
                        <input id="fontColor" v-model="colors.fontColor" />
                    </div>
                    <div class="label w-50 color">
                        <p>Button Color</p>
                        <input id="btnColor" type="color" v-model="colors.btnColor" />
                        <input id="btnColor" v-model="colors.btnColor" />
                    </div>
                    <div class="label w-50 color">
                        <p>Button Font Color</p>
                        <input id="btnFontColor" type="color" v-model="colors.btnFontColor" />
                        <input id="btnFontColor" v-model="colors.btnFontColor" />
                    </div>                     
                </div>
                <div v-if="eFace.face == 'front'">
                    <div class="label">
                        <p>Category</p>
                        <select v-model="card.cat" style="width: calc(100% - 7px);"><option v-for="cat in cats">{{ cat }}</option></select>
                    </div>
                    <div v-if="!card.rewardJoinCard">
                        <div v-if="!card.loyaltyCard">
                            <div class="label w-50">
                                <p>Loyalty Rewards</p>
                                <input type="checkbox" v-model="card.loyaltyCard" style="margin: 4px 0px;float: left;background-color: white;" @change="setLoyaltyCard(card.loyaltyCard)" />
                            </div>
                            <div class="label w-50">
                                <p>Refer Rewards</p>
                                <input type="checkbox" v-model="card.rewardJoinCard" style="margin: 4px 0px;float: left;background-color: white;" @change="setReferCard(card.rewardJoinCard)" />
                            </div>
                        </div>
                    </div>
                    <div class="label" v-if="!card.rewardJoinCard && card.loyaltyCard">
                        <p>Loyalty Reward</p>
                        <input type="checkbox" v-model="card.loyaltyCard" style="margin: 4px 0px;float: left;background-color: white;" @change="setLoyaltyCard(card.loyaltyCard)" />
                        <input style="width: calc(100% - 51px);position: relative;left:10px;color:black;font-size: 20px;" v-model="card.loyaltyTitle" placeholder="Loyalty Button Title" />
                    </div>
                    <div class="label" v-if="!card.loyaltyCard && card.rewardJoinCard">
                        <p>Refer Reward</p>
                        <input type="checkbox" v-model="card.rewardJoinCard" style="margin: 4px 0px;float: left;background-color: white;" @change="setReferCard(card.rewardJoinCard)" />
                        <input style="width: calc(100% - 51px);position: relative;left:10px;color:black;font-size: 20px;" v-model="card.referTitle" placeholder="Refer Button Title" />
                    </div>
                    <div class="label" v-if="!( card.loyaltyCard || card.rewardJoinCard )">
                        <p>Expire</p>
                        <input v-model="card.expireAd" type="checkbox" style="margin: 4px 0px;float: left;background-color: white;" @change="checkExpireAd" />
                        <p style="width: calc(100% - 51px);height:30px;border: 1px solid black;background-color:whitesmoke;line-height: 30px;padding: 0px 5px;position: relative;left:33px;color:black;font-size: 20px;" @click="setExpire = true">{{ card.u_expires }}</p>
                    </div>
                </div>
                <div v-if="eFace.face == 'loyalty'">
                    <div class="label w-50" style="opacity: 0;">
                        <p>Hello</p>
                        <input />
                    </div>
                    <div class="label w-50">
                        <p>Loyalty Qty</p>
                        <input v-model.number="card.loyaltyQty" @keyup="setLoyaltyQty($event)" />
                    </div>
                    <div class="label">
                        <p class="btn" style="width: calc(100% - 20px)" :style="{ backgroundColor: !(card.loyaltyPlain || card.loyaltyStamp) ? 'tomato' : '' }" @click="editStamps = !editStamps">loyalty stamps</p>
                    </div>
                    <div class="label">
                        <p>SMS Reward</p>
                        <textarea v-model="eFace.SMSRewardMessage"></textarea>
                    </div>
                    <div class="label">
                        <p>App Alert Reward</p>
                        <textarea v-model="eFace.appAlertReward"></textarea>
                    </div>
                </div>                
                <div v-if="eFace">
                    <div class="label">
                        <p class="btn" :style="{ width: eFace.src ? 'calc(100% - 140px)' : 'calc(100% - 20px)' }" @click="addBackground(false)">background</p>
                        <div v-if="eFace.src">
                            <div class="label" style="width: 40px;margin-left:20px;margin-right: 10px;margin-top: -15px;">
                                <p>Fixed</p>
                                <input v-model="eFace.fixedBackground" type="checkbox" style="background-color: white;" />
                            </div>
                            <div class="label" style="width: 40px;margin-left:10px;margin-right: 10px;margin-top: -15px;">
                                <p>Parallax</p>
                                <input v-model="eFace.parralaxBackground" type="checkbox" style="background-color: white;" />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="eFace.face == 'home'">
                    <label class="label w-50">
                        <p class="btn" @click="showAssets">Site Assets</p>
                    </label>
                </div>
            </div>
            <div v-if="group && group.btns.length > 0" class="group-btns label">
                <div class="group-btn-type" v-for="(btn,i) in group.btns" :style="{ backgroundColor: btn.selected ? 'rgba(255,255,255,0.1)' : '' }">
                    <p  @click="btn.selected = !btn.selected">{{ btn.type }}</p>
                    <div class="cross" @click="(group.btns = group.btns.filter(b => b != btn), btn.selected = false)"></div>
                </div>
                <p class="btn" @click="groupBtns(group)">Group Buttons</p>
            </div>
            <div v-for="face in card.faces.filter(f => f.selected)" v-if="!eFace">
                <div v-for="(btn,i) in face.btns.filter(b => b.selected)" :key="i">
                    <div v-if="face.btns.indexOf(btn) != 0" class="arrow up" @click="moveBtn(face,btn,-1)"></div>
                    <div v-if="face.btns.indexOf(btn) != face.btns.length -1" class="arrow down" @click="moveBtn(face,btn,+1)"></div>
                    <div class="cross" @click="removeBtn(face,btn)"></div>
                    <p class="field-title">{{ btn.title || btn.type }}</p>
                    <div class="fields top-fields" @change="updateDefault(btn,$event)">
                        <div v-for="field in ['top','left','width','height']" @keyup="updateBtn(btn)" @keydown="[40,38].indexOf($event.keyCode) > -1 && updateBtn(btn,$event)" class="label w-50">
                            <p>{{ field }}</p>
                            <input :id="field" v-model.number="btn[field]" />
                        </div>
                        <div class="label">
                            <p class="btn" style="width: calc(100% - 20px);;margin-top: 0px;margin-bottom: -5px;" @click="centerButton('center',btn)" >centre</p>
                        </div>
                        <div v-if="['text','button','input','group'].indexOf(btn.type) > -1">
                            <div class="label w-50">
                                <p class="btn" @click="centerButton('center-left',btn)">center left</p>
                            </div>
                            <div class="label w-50">
                                <p class="btn" @click="centerButton('center-right',btn)">center right</p>
                            </div>
                        </div>
                        <div v-if="['group','text','button','input'].indexOf(btn.type) == -1" class="label">
                            <p>Button Name</p>
                            <input v-model="btn.title" />
                        </div>
                        <div v-if="btn.type == 'group' && btn.btns.find(btn => btn.type == 'input')">
                            <div class="label w-50">
                                <p>Label Font Size</p>
                                <input id="fontSize" v-model="btn.fontSize" @keyup="updateBtn(btn)" @keydown="[40,38].indexOf($event.keyCode) > -1 && updateBtn(btn,$event)"/>
                            </div>
                            <div class="label color w-50" @mousemove="updateBtn(btn)" @keyup="updateBtn(btn)" @change="updateBtn(btn)">
                                <p>Label Font Colour</p>
                                <input id="fontColor" type="color" v-model="btn.fontColor" />
                                <input id="fontColor" v-model="btn.fontColor" />
                            </div>
                            <div class="label sub-input">
                                <p>Group Name</p>
                                <input  v-model="btn.title" />
                            </div> 
                            <div class="label">
                                <p>Server Function</p>
                                <input v-model="btn.wsService" />
                            </div>  
                            <div v-for="(btn,i) in btn.btns.filter(b => b.type == 'input')" :key="i" class="label sub-input">
                                <div class="label">
                                    <p>{{ btn.fieldTitle }}</p>
                                    <input v-model="btn.field" />
                                </div>
                            </div>
                        </div>
                        <div v-if="btn.type == 'quill'">
                            <div class="label">
                                <p class="btn" style="width: calc(100% - 20px);" :style="{ backgroundColor: !btn.quill_id ? 'tomato' : '' }" @click="editQuill(btn)">edit quill</p>
                            </div> 
                        </div>
                        <div v-if="btn.type == 'wallet'" class="label">
                            <select v-model="btn.wallet_id"><option v-for="wallet in [{ title: 'Select Wallet', _id: '' }].concat(wallets)" :value="wallet._id">{{ wallet.title }}</option></select>
                        </div>
                        <div v-if="btn.type == 'stamps'">
                            <div class="label w-50">
                                <p>Loyalty Qty</p>
                                <input v-model.number="card.loyaltyQty" @keyup="setLoyaltyQty($event)" />
                            </div>
                            <div class="label">
                                <p class="btn" style="width: calc(100% - 20px)" :style="{ backgroundColor: !(card.loyaltyPlain || card.loyaltyStamp) ? 'tomato' : '' }" @click="editStamps = !editStamps">loyalty stamps</p>
                            </div>
                        </div>
                        <div v-if="btn.type == 'button'">
                            <div class="label w-50">
                                <p>Button Action</p>
                                <select v-model="btn.action"><option v-for="action in btnActions">{{ action }}</option></select>
                            </div>
                            <div class="label w-50">
                                <p>Hide Button</p>
                                <input type="checkbox" v-model="btn.hideButton" style="background-color:white" />
                            </div>
                            <div v-if="btn.action == 'page'" class="label">
                                <p>Target Page</p>
                                <select v-model="btn.page_id"><option v-for="page in [{ title: 'Select Page' }].concat(pages).filter(p => p._id != faces[0] && faces[0]._id)" :value="page._id">{{ page.title }}</option></select>
                            </div>
                            <div v-if="btn.action == 'submit'" class="label">
                                <p>Submit Form Group</p>
                                <select @change="setBtnSubmit(btn,$event)" v-model="btn.submitGroup"><option v-for="btnGroup in [{ title: 'Select Group' }].concat(card.faces.find(f => f.selected) && card.faces.find(f => f.selected).btns.filter(b => b.type == 'group').map(b => { return { title: b.title } }))">{{ btnGroup.title }}</option></select>
                            </div>
                            <div v-if="btn.action == 'submit'" class="label">
                                <p>Success Page</p>
                                <select v-model="btn.page_id" ><option v-for="page in [{ title: 'Select Page' }].concat(pages)" :value="page._id">{{ page.title }}</option></select>
                            </div>
                            <div class="label" v-if="btn.action == 'submit'">
                                <p>Server Function</p>
                                <input v-model="btn.wsService" />
                            </div>                         
                            <div v-if="btn.action == 'wallet'" class="label">
                                <select v-model="btn.wallet_id"><option v-for="wallet in [{ title: 'Select Wallet' }].concat(wallets)" :value="wallet._id">{{ wallet.title }}</option></select>
                            </div>
                            <div v-if="btn.action == 'slide'" class="label">
                                <p class="btn" style="width: calc(100% - 20px);" :style="{ backgroundColor: !btn.quill_id ? 'tomato' : ''}" @click="editQuill(btn,'CSlide')">Edit Slide Text</p>
                            </div>
                        </div>
                        <div v-if="['text','button'].indexOf(btn.type) > -1" @keyup="updateBtn(btn)" @keydown="[40,38].indexOf($event.keyCode) > -1 && updateBtn(btn,$event)" >
                            <div v-if="btn.type == 'button'" class="label">
                                <p class="btn" style="width: calc(100% - 20px);" @click="addButtonImage(face,btn)">button image</p>
                            </div>
                            <div class="label w-50">
                                <p>Font Size</p>
                                <select id="fontSize" v-model="btn.fontSize" @change="updateBtn(btn)"><option v-for="fontSize in fontSizes">{{ fontSize }}</option></select>
                            </div>
                            <div class="label w-50">
                                <p>Line Height</p>
                                <input id="lineHeight" v-model="btn.lineHeight" />
                            </div>
                            <div class="label w-50">
                                <p>Text Align</p>
                                <select id="textAlign" v-model="btn.textAlign" @change="updateBtn(btn)"><option v-for="align in ['center','left','right','justify']">{{ align }}</option></select>
                            </div>
                            <div class="label w-50">
                                <p>Font Family</p>
                                <select id="fontFamily" v-model="btn.fontFamily" @change="updateFont(btn)"><option v-for="font in fontFamilies">{{ font.font }}</option></select>
                            </div>
                        </div>
                        <div v-if="['button','group'].indexOf(btn.type) == -1">
                            <div class="label w-50 color" v-if="btn.backgroundColor" @mousemove="updateBtn(btn)">
                                <p>Background Color</p>
                                <input id="backgroundColor" type="color" v-model="btn.backgroundColor" />
                                <input id="backgroundColor" v-model="btn.backgroundColor" />
                            </div>
                            <div class="label w-50 color" v-if="btn.fontColor" @mousemove="updateBtn(btn)">
                                <p>Font Color</p>
                                <input id="fontColor" type="color" v-model="btn.fontColor" />
                                <input id="fontColor" v-model="btn.fontColor" />
                            </div>
                            <div class="label w-50" v-if="btn.type == 'text'">
                                <div class="label w-50 checkbox">
                                    <p><i>Italic</i></p>
                                    <input type="checkbox" v-model="btn.italic" @change="updateBtn(btn)" />
                                </div>
                                <div class="label w-50">
                                    <p>Weight</p>
                                    <select v-model="btn.fontWeight" @change="updateBtn(btn)"><option v-for="weight in fontWeights">{{ weight }}</option></select>
                                </div>
   
                            </div>
                        </div>
                        <div v-if="btn.type == 'input'">
                            <div class="label w-50">
                                <p>label font size</p>
                                <input id="fontSize" v-model.number="btn.fontSize" @keyup="[40,38].indexOf($event.keyCode) == -1 && updateBtn(btn)" @keydown="[40,38].indexOf($event.keyCode) > -1 && updateBtn(btn,$event)" />
                            </div>
                            <div class="label w-50">
                                <p>input font size</p>
                                <input id="inputFontSize" v-model.number="btn.inputFontSize" @keyup="[40,38].indexOf($event.keyCode) == -1 && updateBtn(btn)" @keydown="[40,38].indexOf($event.keyCode) > -1 && updateBtn(btn,$event)" />
                            </div>
                            <div class="label w-50">
                                <p>Input Padding</p>
                                <input id="inputPadding" v-model.number="btn.inputPadding" @keyup="[40,38].indexOf($event.keyCode) == -1 && updateBtn(btn)" @keydown="[40,38].indexOf($event.keyCode) > -1 && updateBtn(btn,$event)" />
                            </div>
                            <div class="label w-50">
                                <p>Box Padding</p>
                                <input id="paddingBottom" v-model.number="btn.paddingBottom" @keyup="[40,38].indexOf($event.keyCode) == -1 && updateBtn(btn)" @keydown="[40,38].indexOf($event.keyCode) > -1 && updateBtn(btn,$event)" />
                            </div>
                            <div class="label">
                                <p>Title</p>
                                <input v-model="btn.fieldTitle" />
                            </div>
                            <div class="label" style="width: calc(100% - 120px);">
                                <p>Placeholder</p>
                                <input v-model="btn.placeholder" />
                            </div>
                            <div class="label" style="width: 60px">
                                <p>Checkbox</p>
                                <input type="checkbox" v-model="btn.checkbox" style="background-color: white;margin-top:4px" />
                            </div>
                            <div class="label w-btns-3" @click="updateBtn(btn,$event)">
                                <p id="inputWidth" class="btn"> 1 </p>
                                <p id="inputWidth" class="btn"> 1 / 2 </p>
                                <p id="inputWidth" class="btn"> 1 / 3</p>
                            </div>
                        </div>
                        <div v-if="btn.type == 'box'">
                            <div class="label w-50">
                                <p>Border Radius</p>
                                <input id="borderRadius" v-model.number="btn.borderRadius" @keyup="[40,38].indexOf($event.keyCode) == -1 && updateBtn(btn)" @keydown="[40,38].indexOf($event.keyCode) > -1 && updateBtn(btn,$event)" />
                            </div>
                            <div class="label w-50">
                                <p>Opacity</p>
                                <input id="opacity" v-model.number="btn.opacity" @keyup="[40,38].indexOf($event.keyCode) == -1 && updateBtn(btn)" @keydown="[40,38].indexOf($event.keyCode) > -1 && updateBtn(btn,$event)" />
                            </div>
                        </div>
                        <div v-if="btn.type == 'button'">
                            <div class="label w-50 color" @mousemove="updateBtn(btn)" @change="updateBtn(btn)">
                                <p>Button Color</p>
                                <input id="btnColor" type="color" v-model="btn.btnColor" />
                                <input id="btnColor" v-model="btn.btnColor" />
                            </div>
                            <div class="label w-50 color" v-if="btn.btnFontColor" @mousemove="updateBtn(btn)">
                                <p>Btn Font Color</p>
                                <input id="btnFontColor" type="color" v-model="btn.btnFontColor" />
                                <input id="btnFontColor" v-model="btn.btnFontColor" />
                            </div>
                            <div class="label w-50" @keyup="[40,38].indexOf($event.keyCode) == -1 && updateBtn(btn)" @keydown="[40,38].indexOf($event.keyCode) > -1 && updateBtn(btn,$event)">
                                <p>Border Radius</p>
                                <input id="borderRadius" v-model.number="btn.borderRadius" />
                            </div>
                            <div class="label w-50" @keyup="[40,38].indexOf($event.keyCode) == -1 && updateBtn(btn,$event)" @keydown="[40,38].indexOf($event.keyCode) > -1 && updateBtn(btn,$event)">
                                <p>Centered Width</p>
                                <input id="size" v-model.number="btn.size" />
                            </div>
                            <div class="label w-50" @keyup="[40,38].indexOf($event.keyCode) == -1 && updateBtn(btn,$event)" @keydown="[40,38].indexOf($event.keyCode) > -1 && updateBtn(btn,$event)">
                                <p>Border Width</p>
                                <input id="borderWidth" v-model.number="btn.borderWidth" />
                            </div>
                            <div class="label w-50 color" @mousemove="updateBtn(btn,$event)" @change="updateBtn(btn,$event)">
                                <p>Border Colour</p>
                                <input id="borderColor" type="color" v-model="btn.borderColor" />
                                <input id="borderColor" v-model="btn.borderColor" />
                            </div>
                            <div class="label">
                                <p>Button Text</p>
                                <textarea v-model="btn.value"></textarea>
                                <!-- <input v-model="btn.value" placeholder="Enter Button Text" /> -->
                            </div>
                        </div>
                        <div v-if="btn.type == 'image'" class="label">
                            <p class="btn" style="width: calc(100% - 20px);;margin-top: 0px;margin-bottom: -5px;" @click="replaceImage(face,btn)">replace picture</p>
                        </div>
                        <div v-if="btn.type == 'qr'" class="label">
                            <p>Refresh Offer</p>
                            <input type="checkbox" v-model="card.isBottomless" style="background-color: white;float: left;" @change="card.redeemAd = !card.redeemAd" />
                            <select style="width: calc(100% - 38px);margin: 0px;float: left;" v-if="!card.redeemAd" v-model="card.bottomless"><option v-for="bottom in bottomless">{{ bottom }}</option></select>
                        </div>
                        <div v-if="btn.type == 'text'" class="label">
                            <p>Text Content</p>
                            <textarea v-model="btn.value"></textarea>
                        </div>
                        <div v-if="btn.type == 'video'">
                            <div class="label w-50">
                                <p class="btn" @click="uploadVideo(btn)">upload</p>
                            </div>
                            <div class="label w-50">
                                <p class="btn" @click="urlVideo(btn)">enter URL</p>
                            </div>
                        </div>
                        <div v-if="btn.type == 'terms'">
                            <div class="label">
                                <p class="btn" style="width: calc(100% - 20px);" :style="{ backgroundColor: !btn.terms_id ? 'tomato' : '' }" @click="editTerms(btn)">{{ btn.terms_id ? 'edit terms' : 'add terms' }}</p>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
        <div v-if="setExpire" class="v-alert">
            <header><p>Set Card Expire</p><div class="x" @click="setExpire = false"></div></header>
            <div class="label">
                <p style="width:100px">Expires</p>
                <div class="date-time-box" @change="changeDate">
                    <div class="label w-50">
                        <p>Hr</p>
                        <select v-model="hour"><option v-for="Hr in hours">{{ Hr }}</option></select>
                    </div>
                    <div class="label w-50">
                        <p>Min</p>
                        <select v-model="minute"><option v-for="Min in minutes">{{ Min }}</option></select>
                    </div>
                </div> 
                <div class="date-time-box" @change="changeDate"> 
                    <div class="label w-33">
                        <p>Day</p>
                        <select v-model="day"><option v-for="Day in days">{{ Day }}</option></select>
                    </div>    
                    <div class="label w-33">
                        <p>Mth</p>
                        <select v-model="month"><option v-for="Month in months">{{ Month }}</option></select>
                    </div> 
                    <div class="label w-33">
                        <p>Year</p>
                        <select v-model="year"><option v-for="Year in years">{{ Year }}</option></select>
                    </div>                                       
                </div>
            </div>
            <div class="btns">
                <p class="btn" @click="setExpiryDate">save date</p>
            </div>
        </div>
        
        <div class="font-box" v-if="addingFonts">
            <div v-for="(font,i) in addingFonts">
                <div>
                    <p :class="'font-'+font.font.replace(/ /g,'').toLowerCase()">{{ font.font }}</p>
                    <canvas></canvas>
                </div>
                
            </div>
        </div>
        <div v-if="showClientColors" class="v-modal">
            <mHeader title="My Color Editor" @exit="showClientColors = false" />
            <div class="content-box">
                <p class="help-text">Change here will be appled to every page and button</p>
                <div class="label w-50">
                    <p>Page Background Colour</p>
                    <div class="color-box" id="client.backgroundColor" :style="{ backgroundColor: client.backgroundColor }">
                        <input v-model="client.backgroundColor" type="color" />
                        <input v-model="client.backgroundColor" />
                    </div>
                </div>
                <div class="label w-50">
                    <p>Page Font Colour</p>
                    <div class="color-box" id="client.fontColor" :style="{ backgroundColor: client.fontColor }">
                        <input v-model="client.fontColor" type="color" />
                        <input v-model="client.fontColor" />
                    </div>
                </div>
                <div class="label w-50">
                    <p>Button Color</p>
                    <div class="color-box" id="client.btnColor" :style="{ backgroundColor: client.btnColor }">
                        <input v-model="client.btnColor" type="color" />
                        <input v-model="client.btnColor" />
                    </div>
                </div>
                <div class="label w-50">
                    <p>Button Font Colour</p>
                    <div class="color-box" id="client.btnFontColor" :style="{ backgroundColor: client.btnFontColor }">
                        <input v-model="client.btnFontColor" type="color" />
                        <input v-model="client.btnFontColor" />
                    </div>
                </div>
                <div class="label w-50">
                    <p>Border Colour</p>
                    <div class="color-box" id="client.borderColor" :style="{ backgroundColor: client.borderColor }">
                        <input v-model="client.borderColor" type="color" />
                        <input v-model="client.borderColor" />
                    </div>
                </div>
                <div class="label w-50">
                    <p>Border Width</p>
                    <input v-model="client.borderWidth" style="width:60px"/>
                </div>
                <div class="btns">
                    <p class="btn" @click="updateClientInherits(client)">save</p>
                </div>
            </div>
            <mSizer />
        </div>
        <div v-if="previewPage || previewCard" class="fixed-scroller" style="display: flex;justify-content: space-around;align-items: center;">
            <div v-if="previewPage" style="width: 414px;height:1100px;background-color: white">
                <!-- <Page :page="previewPave" /> -->
            </div>
            <div v-if="previewCard" style="width: 414px;height:110px;background-color: white;">
                <Card :card="previewCard" />
            </div>
        </div> 
        <div v-if="movingBtn" class="mover-svg" style="position: fixed;left:-5000px">
            <div class="svg-container">
                <svg xmlns="http://www.w3.org/2000/svg" :width="movingBtn.width+60+'px'" :height="movingBtn.height+60+'px'">
                    <rect class="svg-edit-box" :height="movingBtn.height" :width="movingBtn.width" fill="none" style="stroke:black;stroke-width:2;stroke-dasharray:10 5" x="30" y="30"></rect>
                    <rect height="4" :width="movingBtn.width+30" y="9" x="6" fill-opacity="null" stroke-opacity="null" fill="#c0c0c0"/>
                    <rect height="4" :width="movingBtn.width+30" :y="movingBtn.height+45" x="6" fill="#c0c0c0"/>
                    <rect :height="movingBtn.height+30" width="4" y="7" x="10" fill="#c0c0c0"/>
                    <rect :height="movingBtn.height+30" width="4" y="7" :x="movingBtn.width+46" fill="#c0c0c0"/>
                    <circle id="nw" fill="#c0c0c0" stroke="#555555" stroke-width="2.5" r="10" cx="12" cy="12" />
                    <circle id="ne" fill="#c0c0c0" stroke="#555555" stroke-width="2.5" r="10" :cx="movingBtn.width+48" cy="12" />
                    <circle id="se" fill="#c0c0c0" stroke="#555555" stroke-width="2.5" r="10" :cx="movingBtn.width+48" :cy="movingBtn.height+48" />
                    <circle id="sw" fill="#c0c0c0" stroke="#555555" stroke-width="2.5" r="10" cx="12" :cy="movingBtn.height+48" />
                    <rect id="e" :height="30" width="10" stroke="#555555" stroke-width="2.5" :y="( movingBtn.height / 2 ) + 15" :x="movingBtn.width+43" fill="#c0c0c0"/>
                    <rect id="w" :height="30" width="10" stroke="#555555" stroke-width="2.5" :y="( movingBtn.height / 2 ) + 15" :x="7" fill="#c0c0c0"/>
                    <rect id="n" :height="10" width="35" stroke="#555555" stroke-width="2.5" :x="( movingBtn.width / 2 ) + 12" :y="7" fill="#c0c0c0"/>
                    <rect id="s" :height="10" width="35" stroke="#555555" stroke-width="2.5" :x="( movingBtn.width / 2 ) + 12" :y="movingBtn.height + 42" fill="#c0c0c0"/>
                </svg>
            </div>
        </div>
        <div v-if="changeHomeJoin" class="v-alert">
            <header class="header" style="border-left:0px;border-right:0px;border-bottom:1px solid #c0c0c0;"><p style="line-height: 1.4em;">Make Main Page</p><div class="x" @click="changeHomeJoin = false"></div></header>
            <div>
                <p class="btn b" style="width:calc(100% - 10px)" @click="setAppPage('faceHome_id',eFace)">Make Join Page</p>
                <p class="btn b" style="width:calc(100% - 10px)" @click="setAppPage('faceJoin_id',eFace)">Make Home Page</p>
            </div>
        </div>
        <div v-if="previewCard" class="fixed-scroller">
            <div class="v-alert" style="width: 446px;">
                <header><p>Preview Card</p><div class="x" @click="previewCard = false"></div></header>
                <CCard :card="card" />
            </div>
            
        </div>   
    </div>
</template>

<script>

import Alert from '@/utils/Alert.js';
import UploadFile from '@/utils/UploadFile.js'
import postMinify from '@/utils/postMinify.js'
import WebSoc from '@/utils/WebSoc.js'
import getCodes from '@/utils/addCode.js';
import { format } from 'date-fns' 
import Quill from '@/components/Quill.vue'
import MonacoEditor from 'monaco-editor-vue';
import { mapActions, mapMutations } from 'vuex'
//import { VueEditor, Quill } from 'vue2-editor'

import CCard from '../components/Cards/CCard';
import CComp from '../components/Cards/Comp';
import CImage from '../components/Cards/Image'
import CLink from '../components/Cards/Link';
import CQr from '../components/Cards/Qr'
import CRotate from '../components/Cards/Rotate'
import CTerms from '../components/Cards/Terms'
import CText from '../components/Cards/Text'
import CVideo from '../components/Cards/Video';
import CBox from '../components/Cards/Box'
import Card  from '../components/Card.vue';
import CButton from '../components/Cards/Button.vue'
import CStamp from '../components/Cards/CStamp.vue'
import CQrRefer from '../components/Cards/QrRefer.vue'
import CWallet from '../components/Cards/CWallet'
import CQuill from '../components/Cards/CQuill'
import CInput from '../components/Cards/CInput'
import CGroup from '../components/Cards/CGroup'
import CBraintree from '../components/Cards/CBraintree'
import EditBox from '../components/Cards/EditBox.vue'
import EditImage from '@/utils/EditImage.js';
import postIMG from '../utils/postIMG.js';
import mHeader from '../components/mHeader'
import mSizer from '../components/mSizer'
//import appPagesView from '../components/appPages';

import PageHeader from '../components/Blocks/PageHeader';
export default {
    name: 'card-designer',
    components: {
        Quill,
        Card,
        CComp,
        CImage,
        CLink,
        CQr,
        CRotate,
        CTerms,
        CText,
        CVideo,
        CBox,
        CStamp,
        EditBox,
        CButton,
        CQrRefer,
        CWallet,
        CQuill,
        CInput,
        CGroup,
        CBraintree,
        PageHeader,
        mHeader,
        mSizer,
        CCard
        //appPagesView
    },
    computed: {
        client_id () { return this.$store.state.client_id },
        //pages () { return this.$store.state.DB.pages },
        //wallets () { return this.$store.state.DB.wallets },
        storeClient () { return this.$store.state.client }
    },
    watch: {
        /*
        'colors': {
            deep: true,
            handler ( value, old ) {
                ['backgroundColor','fontColor','btnColor','btnFontColor'].forEach(key => {
                    this.eFace[key] = value[key];
                })
            }
        },
        */
       'card.height' ( height ) {
            this.card.faces.forEach(face => {
                typeof face.height == 'number' && ( face.height = height );
            })
       },
        'client.backgroundColor' ( value ) {
            this.setColor('backgroundColor',value);
        },
        'client.fontColor' ( value ) {
            this.setColor('fontColor',value);
        },
        'client.btnColor' ( value ) {
            this.setColor('btnColor',value);
        },
        'client.btnFontColor' ( value ) {
            this.setColor('btnFontColor',value);
        },
        'client.borderColor' ( value ) {
            this.setColor('borderColor',value);
        },
        'client.borderWidth' ( value ) {
            this.setColor('borderWidth',value);
        }
    },
    props: {
        home: Boolean
    },
    data () {
        return {
            movingBtn: false,
            changeHomeJoin: false,
            appNav: [
                { title: 'Buttons', selected: false },
                { title: 'Pages', selected: true },
                { title: 'Cards', selected: false },
                
            ],
            copyBtns: [],
            appNavSelected: '',
            pages: [],
            wallets: [],
            cards: [],
            _id: false,
            setExpire: false,
            showClientColors: false,
            previewPage: false,
            previewCard: false,
            appPages: [],
            client: {
                headerHeight: 50
            },
            card: {
                height: 500,
                width: 414,
                title: '',
                faces: []
            },
            loyaltyFields: {
                loyaltyCard: false,
                loyaltyTitle: '',
                rewardJoinCard: false,
                rewardTitle: '',
                loyaltyQty: 9,
                expireAd: false,
                expires: false,
                u_expires: '',
                bottomless: 'immediate',
                redeemAd: true,
                isBottomless: false,
                cat: 'No Category',
            },
            faces: [
                { face: 'front', show: true, src: '', btns: [], selected: false, title: 'Frontface', backgroundColor: '', fontColor: '', btnColor: '', btnFontColor: '' },
                { face: 'back', show: false, src: '', btns: [], selected: false, title: 'Backface', backgroundColor: '', fontColor: '', btnColor: '', btnFontColor: '' }
            ],
            group: false,
            loyaltyBtns: [
                    { title: 'Text', type: 'text', component: 'CText', selected: false, style: '', top: 30, left: 0, width: 414, height: 42, value: 'PERONI REWARDS', fontFamily: 'Open Sans', fontSize: 32, lineHeight: 1.2, css: '', bold: false, italic: false, textAlign: 'center', fontColor: '#000000', fontWeight: 'normal' },
                    { title: 'Text', type: 'text', component: 'CText', selected: false, style: '', top: 426, left: 38, width: 338, height: 100, value: "Every time you buy a pint of Peroni, we'll give you a stamp. Collect 9 stamps and you'll receive your 10th pint of Peroni free on us.", fontFamily: 'Open Sans', fontSize: 20, lineHeight: 1.2, css: '', bold: false, italic: false, textAlign: 'center', fontColor: '#000000', fontWeight: 'normal' },
            ],
            inherits: ['backgroundColor','backgroundOpacity','fontColor','btnColor','btnFontColor','borderColor','borderWidth'],
            typeFaces: [
                { type: 'Page', component: 'CPage', title: 'New Page', width: 414, height: 1100, faces: [
                    {   face: 'page', 
                        show: true, 
                        btns: [],
                        selected: true, 
                        src: '',
                        width: 414, height: 1100,
                        backgroundColor: '', backgroundOpacity: 1, fontColor: '', btnColor: '', btnFontColor: '', borderColor: '', borderWidth: ''
                    }
                ], backgroundColor: '', backgroundOpacity: 1, fontColor: '', btnColor: '', btnFontColor: '', borderColor: '', borderWidth: '', parralaxSrc: false,  }
            ],
            faceLoyalty: { 
                face: 'loyalty', faceLoyalty: true, show: true, src: '', 
                btns: [
                    { title: 'Stamps', type: 'stamps', component: 'CStamp', loyaltyStamp: '', qty: 4, loyaltyPlain: '', selected: false, grid: [], top: 114, left: 66, width: 280, height: 280, value: '' }, 
                    { title: 'QR Code', type: 'qr', component: 'CQr', selected: false, top: 570, left: 117, width: 180, height: 180, value: '' },
                ], 
                selected: false, 
                title: 'Loyalty Reward', 
                backgroundColor: '',
                SMSRewardMessage: 'Have a Free Pint of Peroni on us !',
                appAlertReward: 'Congratulations, you have just been awarded a Free Pint of Peroni',
                width: 414, height: 1100 
            },
            editPages: false,
            assets: {
                siteTitle: 'Assets',
                siteBrand: '',
                headerColor: '#FFFFFF',
                headerHeight: 50,
                headerPadding: 5,
                headerStrokeWidth: 15,
                headerAccentColor: '#000000',
                headerBackBevel: true,
                favicon: '',
                showBack: false,
                showAvatar: false, 
                homeHeader: true,
                acctPage_id: ''
            },
            facesPage: [
                {
                    face: 'page', facePage: true, show: true, src: '',
                    btns: [

                    ],
                    selected: false, 
                    title: 'New Page', 
                    backgroundColor: '', 
                    fontColor: '',
                    btnColor: '',
                    btnFontColor: '',
                    src: '',
                    parralaxBackground: false,
                    fixedBackground: false,
                    siteTitle: 'facesPage',
                    pageHeader: '',
                    back: '',
                    avatar: '',
                    favicon: '',
                    width: 414, height: 1100 
                }
            ],
            facesHome: [
                {
                    face: 'home', faceHome: true, show: true, src: '',
                    btns: [

                    ],
                    selected: false, 
                    title: 'Home Page', 
                    backgroundColor: '', 
                    fontColor: '',
                    btnColor: '',
                    btnFontColor: '',
                    src: '',
                    parralaxBackground: false,
                    fixedBackground: false,
                    siteTitle: 'facesHome',
                    pageHeader: '',
                    back: '',
                    avatar: '',
                    favicon: '',
                    width: 414, height: 1100 
                }
            ],
            facesJoin: [
                {
                    face: 'join', faceJoin: true, show: true, src: '',
                    btns: [

                    ],
                    selected: false, 
                    title: 'Join Page', 
                    backgroundColor: '', 
                    parralaxBackground: false,
                    fixedBackground: false,
                    src: '',
                    width: 414, height: 1100 
                }
            ],
            referBtns: [
                    { title: 'Text', type: 'text', component: 'CText', selected: false, style: '', top: 30, left: 0, width: 414, height: 42, value: 'REFER REWARD', fontFamily: 'Open Sans', fontSize: 32, lineHeight: 1.2, css: '', bold: false, italic: false, textAlign: 'center', fontColor: '#000000', fontWeight: 'normal' },
                    { title: 'Text', type: 'text', component: 'CText', selected: false, style: '', top: 108, left: 38, width: 338, height: 55, value: "Every time refer a friend you'll get a free pint of Peroni free on us.", fontFamily: 'Open Sans', fontSize: 20, lineHeight: 1.2, css: '', bold: false, italic: false, textAlign: 'center', fontColor: '#000000', fontWeight: 'normal' },
            ],
            faceRefer: {
                face: 'refer', faceRefer: true, show: true, src: '',
                btns: [
                    { show: false, title: 'QR Refer', type: 'qr-refer', component: 'CQrRefer', selected: false, top: 222, left: 118, width: 180, height: 180, value: '' }  
                ],
                selected: false, 
                title: 'Refer Reward', 
                backgroundColor: '', 
                width: 414, height: 1100 
            },
            cats: [],
            eFace: {
                backgroundColor: '',
                fontColor: '',
                btnColor: '',
                btnFontColor: ''
            },
            types: [
                //{ title: 'Background', type: 'background', selected: false, style: '', top: 0, left: 0, width: 414  },
                //{ title: 'Header', type: 'image', component: 'CImage', selected: false, style: '', top: 0, left:  0, width: 414, height: 50 },
                { title: 'Wallet', type: 'wallet', component: 'CWallet', selected: false, style: '', top: 0, left: 0, width: 414, wallet_id: '' },
                { title: 'Text', type: 'text', component: 'CText', selected: false, style: '', top: 0, left: 0, width: 414, height: 38, value: '', fontFamily: 'Open Sans', fontSize: 32, lineHeight: 1.2, css: '', bold: false, italic: false, textAlign: 'center', fontColor: '#000000', fontWeight: 'normal' },
                { title: 'Button', type: 'button', submitGroup: 'Select Group', hideButton: false, image: false, action: 'rotate', component: 'CButton', selected: false, style: '', top: 396,left: 87, width: 240, height: 55, size: 240, value: 'BUTTON NAME', borderRadius: 20, borderWidth: 0, borderColor: '', fontFamily: 'Open Sans', fontSize: 20, lineHeight: 1.2, css: '', textAlign: 'center', btnColor: '', btnColor: '#FFFFFF', btnFontColor: '#000000' },
                { title: 'Quill', type: 'quill', component: 'CQuill', selected: false, style: '', top: 0, left: 0, width: 414, quill_id: '', html: '' },
                { title: 'Box', type: 'box', component: 'CBox', selected: false, style: '', top: 0, left: 0, width: 414, opacity: 1, borderRadius: 0, height: 100, value: '', backgroundColor: '#FFFFFF', fontColor: '#000000'},
                { title: 'Picture', type: 'image', component: 'CImage', selected: false, style: '', top: 0, left: 0, width: 414  },
                //{ title: 'Terms', type: 'terms', component: 'CTerms', style: '', action: 'terms', value: '', top: 285, left: 40, width: 334, height: 65, terms_id: '' },
                //{ title: 'Rotate', type: 'rotate', component: 'CRotate', selected: false,  style: '', top: 376, left: 29, width: 350, height: 90, value: '', contentRotate: { style: '', action: 'rotate', top: 0, left: 0, width: 410, height: 90, value: '' } },
                { title: 'QR Code', type: 'qr', component: 'CQr', selected: false, style: '', top: 130, left: 117, width: 180, height: 180, value: '' },
                { title: 'Input', type: 'input', component: 'CInput', checkbox: false, selected: false, style: '', value: '', top: 100, left: 0, width: 414, height: 86, 

                placeholder: 'Placeholder Text', 
                fieldTitle: 'Field Title', 
                field: '$your-field-name', 

                    paddingBottom: 0, 
                    fontSize: 16, 
                    inputFontSize: 22, 
                    inputPadding: 10,
                    inputWidth: '100%', 
                    fontColor: '#000000', backgroundColor: '#FFFFFF',  },
                { title: 'Form', type: 'form', component: 'CForm', selected: false, style: '', top: 0, left: 0, width: 414, height: 900, value: '', btns: [] },
                { title: 'Video', type: 'video', component: 'CVideo', selected: false, fixed: true,  style: '', top: 100, left: 17, width: 380, height: 220, value: '', mov: '' },
                //{ title: 'Link', type: 'link', component: 'CLink', selected: false,  style: '', value: '', top: 300, left: 40, width: 334, height: 65 },
                //{ title: 'Competition', type: 'comp', component: 'CComp', selected: false,  style: '', value: '', top: 285, left: 40, width: 334, height: 65 },
                //{ title: 'Event', type: 'comp', component: 'CComp', selected: false,  style: '', value: '', top: 285, left: 40, width: 334, height: 65 },
                //{ title: 'Buy', type: 'comp', component: 'CComp', selected: false,  style: '', value: '', top: 285, left: 40, width: 334, height: 65 }, 
                { show: false, title: 'Loyalty', type: 'stamps', component: 'CStamp', qty: 9, selected: false, grid: [], top: 100, left: 97, width: 220, height: 220, value: '' },
                { show: false, title: 'QR Refer', type: 'qr-refer', component: 'CQrRefer', selected: false, top: 100, left: 117, width: 180, height: 180, value: '' },  
                { title: 'Braintree', type: 'braintree', component: 'CBraintree', selected: false, component_id: "5fbfdf4361c41b3d2faeddc4" }
            ],
            moving: false,
            fontSizes: new Array(36).fill(true).map((_,i) => i + 12).concat(new Array(35).fill(true).map((_,i) => (i + 24) * 2)).concat(new Array(35).fill(true).map((_,i) => (i + 30) * 4)),
            fontFamilies: [
                //{ font: 'Sans-Serif' },
                //{ font: 'Open Sans', href: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;1,300;1,600&display=swap" },
                //{ font: 'Poppins', href: "https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" },
                //{ font: 'Solway',  href: "https://fonts.googleapis.com/css2?family=Solway:wght@300;400&display=swap" },
                //{ font: 'Roboto', href: 'https://fonts.googleapis.com/css?family=Roboto' },
                //{ font: 'Zhi Mang Xing', href: 'https://fonts.googleapis.com/css2?family=Zhi+Mang+Xing' }
            ],
            fontWeights: [
                'normal',
                'bold',
                'bolder',
                'lighter',
                '100',
                '200',
                '300',
                '400',
                '500',
                '600',
                '700',
                '800',
                '900'
            ],
            config: {
                fontFamily: '',
                fontSize: '',
                fontWeight: '',
                lineHeight: '',
                //backgroundColor: '',
                fontColor: '',
                textAlign: '',
                btnColor: '',
                btnFontColor: '',
                fontColor: '#AA00AA',
                backgroundColor: ''
            },
            colors: {
                backgroundColor: '#FFFFFF',
                fontColor: '#000000',
                btnColor: '#0000FF',
                btnFontColor: '#000000'

            },
            selectedFont: '',
            selectedFontFamily: false,
            hours: new Array(24).fill(true).map((_,i) => i).map(i => i < 10 ? '0'+i : i),
            minutes: new Array(60).fill(true).map((_,i) => i).map(i => i < 10 ? '0'+i : i),
            days: new Array(31).fill(true).map((_,i) => i+1).map(i => i < 10 ? '0'+i : i),
            months: new Array(12).fill(true).map((_,i) => i+1).map(i => i < 10 ? '0'+i : i),
            years: new Array(15).fill(true).map((_,i) => (new Date().getFullYear()-2000)+i),
            hour: '00',
            minute: '00',
            day: '01',
            month: '01',
            year: (new Date().getFullYear() - 2000)+'',
            categories: [],
            bottomless: [
                'immediate',
                '1 Hour',
                '1 day',
                'Monday',
                'Friday',
                '7 days',
                '1st of Month',
                '6 Months',
                '12 Months'
            ],
            quill: false,
            Card: false,
            currentItem: false,
            iScale: 3,
            startFont: 750,
            endFont:  1000,
            showFontSearch: false,
            addingFonts: false,
            editStamps: false,
            editAssets: false,
            transformScale: 1,
            loyalGrids: {
                q9: [
                { x: 0, y: 0 },
                { x: 138, y: 0 },
                { x: 276, y: 0 },
                { x: 0, y: 138 },
                { x: 138, y: 138 },
                { x: 276, y: 138 },
                { x: 0, y: 276 },
                { x: 138, y: 276 },
                { x: 276, y: 276 }
                ],
                q7: [
                { x: 69, y: 0 },
                { x: 207, y: 0 },
                { x: 0, y: 138 },
                { x: 138, y: 138 },
                { x: 276, y: 138 },
                { x: 69, y: 276 },
                { x: 207, y: 276 }
                ]                
            },
            btnActions: [
                'rotate',
                'link',
                //'wallet',
                'page',
                'slide',
                'buy',
                'event',
                'book',
                'competition',
                'submit'
            ],
            hideBoxes: false,
            components: [],
            previewCard: false,
            aKId: "AKIAQGEUICDL4JSPEGWJ",
            AK: "1AlKIocTeHp+R3DC8L8ysMN0/3BAB60/uG3z/Hxr",
            r: "us-west-2"
        }
    },
    beforeDestroy () {
        window.removeEventListener('keydown',this.copyPaste);
    },
    mounted () {
        var now = Date.now();
        ['wallets','cards','pages'].forEach(db => {
            WebSoc.SEND('search',{ DB: db, find: { client_id: this.client_id }},items => {
                db == 'cards' && items.sort((a,b) => a.update < b.update ? -1 : 1).forEach(card => card.selected = false);
                this[db] = items;
                db == 'pages' && this.makeAppPages();
            })
        })
        this.client = JSON.parse(JSON.stringify(this.storeClient));
        this.start();
        
        this.$router.beforeEach(( to,from, next ) => {
            var fromPath = to.path.split('/');
            var toPath = to.path.split('/');
            //console.log({ toPath, fromPath });
            next();
            if ( toPath[1] != 'pagedesigner' ) return;
            if ( toPath[1] == fromPath[1] ) {
                this.start(toPath[2]);
            }
            //console.log('$router.beforeEach',{ to, from });
        })
        setTimeout(() => {
            
            WebSoc.SEND('search',{ DB: 'google-fonts', find: {} },fontFamilies => {

                //console.log('fontFamilies',JSON.parse(JSON.stringify(fontFamilies)));
                //console.log(JSON.stringify(fontFamilies,null,1));
                this.fontFamilies = fontFamilies.filter((f,i) => { f.selected = true; return f.src }).sort((a,b) => a.font < b.font ? -1 : 1);
                //this.fontFamilies.forEach((f,i) => f.selected = );
                
                return;

                this.addingFonts = [
                    { font: 'Open Sans', href: "https://fonts.googleapis.com/css2?family=Open+Sans",  /* :ital,wght@0,300;0,400;0,600;0,700;1,300;1,600&display=swap" */ },
                    { font: 'Poppins', href: "https://fonts.googleapis.com/css2?family=Poppins" /* :ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" */ },
                    { font: 'Solway',  href: "https://fonts.googleapis.com/css2?family=Solway" /* :wght@300;400&display=swap" */ },
                    { font: 'Roboto', href: 'https://fonts.googleapis.com/css?family=Roboto' },
                ].map(f => {
                    f.category =  '';
                    f.fontFamily = f.font;
                    f.fontStyles = [];
                    f.fontWeights = [];
                    return f;
                });

                
                this.addingFonts.forEach((family,i) => {
                    console.log('add',family.font);
                    this.addFonts(family);
                });
                
            });

        },2000)
        
        var adding = {};

        document.fonts.onloadingdone = e => { 
            if ( !Array.isArray(this.addingFonts) ) return; 
            e.fontfaces.forEach(Font => { 
                console.log('Loaded',Font.family);
                var font = this.addingFonts.find(f => f.font == Font.family);
                if ( !font ) return console.log('cardDesigner !font Font',Font);
                if ( adding[font.font] ) return console.log('already adding font',font.font);
                adding[font.font] = true;
                font ? console.log('font',JSON.parse(JSON.stringify(font))) : console.log('!font');
                var qs = '.font-'+font.font.replace(/ /g,'').toLowerCase();
                var p = this.$el.querySelector(qs);
                var canvas = p.nextElementSibling;
                
                if ( font.src ) {
                    
                    var i = document.createElement('img');
                        i.style.border = '1px solid green';
                        i.src = font.src;
                        console.log('got src',font.font);
                        return canvas.parentElement.replaceChild(i,canvas);

                }
                if ( !font.src ) {
                        //console.log('adding canvas',font.font);
                        canvas.width = 400;
                        canvas.height = 30;
                        canvas.style.border = '1px solid red';
                    var ctx = canvas.getContext('2d');
                        ctx.font = '20px '+font.font;
                        ctx.textBaseline = 'middle';
                        ctx.fillText(font.font,5,17);
                        postIMG(canvas.toDataURL(),resp => {
                            if ( resp.size ) return console.log('resp.size',resp.size);
                            if ( resp.url ) {
                                font.src = resp.url;
                                if ( font._id ) {
                                    WebSoc.SEND('update',{ DB: 'google-fonts', _id: font._id, update: { $set: { src: font.src } } },() => {
                                        console.log('update',font.font);
                                    })
                                } else {
                                    WebSoc.SEND('save',{ DB: 'google-fonts', new: font },() => {
                                        console.log('added font',font.font)
                                    });

                                }
                            }
                        })
                }           
            });
        };

    },
    methods: {
        setAppPage ( type, page ) {
            console.log({
                type,
                page: JSON.parse(JSON.stringify(page))
            });
            if ( !page._id ) return Alert.message('You cannot set a page as Join / Home unless it is saved first !');
            this.client[type] = page._id;
            this.makeAppPages();
            console.log({ type });
            console.log('page',page);
            console.log('this.client[type]',this.client[type]);
        },
        colorQuest ( e ) {
            if ( !e.shiftKey ) return this.showClientColors = !this.showClientColors;
            this.changeHomeJoin = true;
        },
        startPreview () {
            this.previewCard = this.card;
        },
        updateClientInherits ( client ) {
            var before = this.inherits.reduce((p,key) => { p[key] = client[key]; return p },{});
            console.log('before',JSON.stringify(before,null,1));
            this.showClientColors = false;
            var update = this.inherits.reduce((p,key) => { console.log('before',key,client[key]); p[key] = client[key];  return p },{});
                update.backgroundOpacity = 1;
            WebSoc.SEND('update',{ DB: 'clients', _id: client._id, update: { $set: update }},() => {
                console.log('updated client',JSON.stringify(update,null,1));
            })
        },
        selectCard ( card, e ) {
            if ( e && e.shiftKey ) {
                e.preventDefault();
                e.stopPropagation();
                if ( !card._id ) return this.cards = this.cards.filter(c => c != card);
                return Alert.yesno('Delete '+card.title+' ?',yes => {
                    if ( !yes ) return;
                    WebSoc.SEND('delete',{ DB: 'cards', _id: card._id },() => console.log('deleted'));
                    this.cards = this.cards.filter(c => c != card);
                })
            }
            
            console.log('selectCard',card);

            this.cards.forEach(Card => Card.selected = Card == card);
            this.currentItem = JSON.stringify(card);
            this.showCard(card);
        },
        selectAppPage ( appPage, e ) {
            if ( e && e.shiftKey ) { 
                e.preventDefault();
                e.stopPropagation();
                return Alert.yesno('Delete '+appPage.page.title+'?',yes => {
                    if ( !yes ) return;
                    this.faces = this.card.faces.filter(f => f._id != appPage.page._id);
                    yes && WebSoc.SEND('delete',{ DB: 'pages', _id: appPage.page._id },() => {
                        this.pages = this.pages.filter(p => p._id != appPage.page._id);
                        this.makeAppPages()
                    })
                })
            }
            
            
            
            appPage.selected = !appPage.selected;
            if ( appPage.selected ) {
                var page = this.showPage(appPage.page);
                this.eFace = page;
                this.currentItem = JSON.stringify(page);
                setSelector(this.appPages.draft);
                setSelector(this.appPages.live);
            } else {
                this.card = { faces: [] };
            }

            function setSelector(pages) {
                if ( !Array.isArray(pages) ) return; 
                pages.forEach(Page => {
                    Page.selected = Page.page._id == appPage.page._id;
                    setSelector(Page.subs);
                })
            }

        },
        makeAppPages () {
            console.log('')
            var pages = this.pages;
            var client = this.client;
        
            var appPages = { live: [], draft: [] }

            pages.forEach(page => {

                if ( [this.client.faceHome_id,this.client.faceJoin_id].indexOf(page._id) > -1 ) {
                    
                    appPages.live.push({ page: page, btns: [], subs: [], selected: false });
                } else {
                    appPages.draft.push(page);
                }                
                
                /*
                if ( page.face == 'home' || page.face == 'join' ) {
                    appPages.live.push({ page: page, btns: [], subs: [], selected: false });
                } else {
                    appPages.draft.push(page);
                }
                */

            });

            appPages.live.forEach(appPage => {
                addSubs(appPage,0)
            });

            function addSubs(appPage, depth) {
                appPage.depth = depth;
                if ( Array.isArray(appPage.page.faces) ) {
                    appPage.page.faces.forEach(face => {
                        face.btns.forEach(btn => {
                            if ( btn.page_id ) {
                                var page = appPages.draft.find(page => page._id == btn.page_id);
                                if ( page ) {
                                    appPages.draft.splice(appPages.draft.indexOf(page),1);
                                    appPage.subs.push({ page: page, btns: [], subs: [], selected: false })
                                }
                            }
                        });
                    })
                } else {
                    appPage.page.btns.forEach(btn => {
                        if ( btn.page_id ) {
                            var page = appPages.draft.find(page => page._id == btn.page_id);
                            if ( page ) {
                                appPages.draft.splice(appPages.draft.indexOf(page),1);
                                appPage.subs.push({ page: page, btns: [], subs: [], selected: false })
                            }
                        }
                    });
                }
                if ( appPage.subs.length > 0 ) appPage.subs.forEach(page => addSubs(page,depth + 1));
            }
            //console.log('appPages',JSON.parse(JSON.stringify(appPages)));
            appPages.draft = ( appPages.draft || [] ).map(page => {  return { page: page, btns: [], subs: [], selected: false } });
            this.appPages = appPages;
        },
        quest ( action ) {
            console.log({ action });
        },
        groupBtns ( group ) {
            var Group = {
                top: Infinity,
                left: Infinity,
                right: 0,
                bottom: 0
            }
            group.btns.forEach(btn => {
                Group.top = Math.min(Group.top,btn.top);
                Group.left = Math.min(Group.left,btn.left);
                Group.bottom = Math.max(Group.bottom,btn.top + btn.height);
                Group.right = Math.max(Group.right,btn.left + btn.width); 
                btn.selected = false;             
            });
            Group.width = Group.right - Group.left;
            Group.height = Group.bottom - Group.top;
            console.log(Group);

            var btn = {
                title: 'Group',
                type: 'group',
                component: 'CGroup',
                cHeight: false,
                cWidth: false,
                crWidth: false,
                crRight: false,
                fontColor: '',
                fontSize: 16, 
                scale: 1,
                top: Group.top,
                left: Group.left,
                width: Group.width,
                height: Group.height,
                selected: true,
                wsService: '$$service-name',
                style: '',
                btns: group.btns
                    .map(b => JSON.parse(JSON.stringify(b)))
                        .map(btn => { btn.top -= Group.top; btn.left -= Group.left; this.updateBtn(btn); return btn })
                            .sort((a,b) => { 
                                if ( a.top != b.top ) return a.top < b.top ? -1 : 1 
                                return a.left < b.left ? -1 : 1
                            }),
                value: ''
            };
            
            btn.btns.forEach(Btn => {
                Btn.backgroundColor = '';
                if ( Btn.type != 'input' ) return;
                if ( !btn.fontColor && Btn.fontColor ) { btn.fontColor = Btn.fontColor }
                if ( !btn.fontSize && Btn.fontSize ) { btn.fontSize = Btn.fontSize };
                Btn.fontColor = Btn.fontSize = '';
                console.log('Btn',JSON.parse(JSON.stringify(Btn)));
            });
            
            console.log('btn.fontSize',btn.fontSize);
            console.log('btn.fontColor',btn.fontColor);

            this.updateBtn(btn);
            group.face.btns = group.face.btns.filter(btn => group.btns.indexOf(btn) == -1);
            group.face.btns.push(btn)
            this.group = false;
            this.selectBtn(group.face,btn);
        },
        start ( type ) {
            //console.log({ type });
            //console.log('this.$route',this.$route);
            switch ( type ) {
                case 'home':
                    var home = true;
                    break;
                case 'join':
                    var join = true;
                    break;
                case 'page':
                    var page = true;
                    break;    
                default:
                    var home = this.$route.params._id == 'home';
                    var join = this.$route.params._id == 'join';
                    var page = this.$route.params._id == 'new-page';
            }

            /*
            if ( this.$route.params._id.length == 24 ) {
                WebSoc.SEND('get',{ DB: 'pages', _id: this.$route.params._id },page => {
                    console.log('this.$route.params._id page',page)
                });
            }
            */
            //console.log('this.$route.params._id',this.$route.params._id);
            window.addEventListener('keydown',this.copyPaste)

           
            var _id = this.$route.params._id;
            //this.addFonts();

            this.getCats();
            var type = this.$route.path.split('/')[1];

            if ( _id && ['home','join'].indexOf(_id) == -1 ) {
                return type == 'pagedesigner' ? this.getPage(_id) : this.getCard(_id);
            }
            if ( !home && !join ) {
                alert('here ?')
                console.log('addPage this.page',this.page);
                console.log('this.faces[0]',JSON.parse(JSON.stringify(this.faces[0])));
                this.selectFace(this.faces[0]);
                this.editPages = page;
            } else {
                //this.editPages = true;
            }
            /*
            WebSoc.SEND('get',{ DB: 'clients', _id: this.client_id, project: { 
                siteTitle: 1,
                headerPlain: 1,
                backWidth: 1,
                backColor: 1,
                bevel: 1,
                avatar: 1,
                favicon: 1,
                backgroundColor: 1, 
                fontColor: 1, 
                btnColor: 1, 
                btnFontColor: 1, 
                borderColor: 1,
                borderWidth: 1,
                backgroundOpacity: 1,
                fonts: 1, 
                pictures: 1,
                siteURL: 1, 
                faceHome_id: 1, 
                faceJoin_id: 1,
                homeHeader: 1,
                siteTitle: 1,
                siteBrand: 1,
                headerColor: 1,
                headerHeight: 1,
                headerPadding: 1,
                headerStrokeWidth: 1,
                headerAccentColor: 1,
                headerBackBevel: 1,
                favicon: 1,
                acctPage_id: 1, 
            } },client => {
            */
            
            var client = this.client;

                if ( home && client.faceHome_id ) { 

                    var page = this.pages.find(p => p._id == client.faceHome_id);

                    !page && WebSoc.SEND('get',{ DB: 'pages', _id: client.faceHome_id },page => {
                        return this.showPage(page);
                    })

                    page && this.showPage(JSON.parse(JSON.stringify(page)))
                
                }

                if ( join && client.faceJoin_id ) {
                    WebSoc.SEND('get',{ DB: 'pages', _id: client.faceJoin_id },page => {
                        return this.showPage(page);
                    })
                }

                if ( home && !client.faceHome_id ) {

                    var faceHome = this.facesHome[0];

                    Object.keys(client).forEach(key => {
                        if ( key == '_id' ) return;
                        client[key] && ( faceHome[key] = client[key] );
                    });
                    this.inherits.forEach(key => {
                        faceHome[key] = client[key];
                    });
                    this.card.height = faceHome.height;
                    this.card.title = faceHome.title;
                    this.faces = this.card.faces = [ faceHome ];
                    this.selectFace(faceHome);
                }

                if ( join && client.faceJoin_id ) {
                    var faceJoin = this.facesJoin[0];
                    ['backgroundColor','fontColor','btnColor','btnFontColor'].forEach(key => {
                        if ( !client[key] ) return faceJoin[key] = this.colors[key];
                        faceJoin[key] = this.colors[key] = client[key];
                    }); 
                    this.card.height = faceJoin.height;
                    this.card.title = faceJoin.title;
                    this.faces = [ faceJoin ];
                    this.selectFace(faceJoin);                   
                }

            //});
        },
        saveAssets () {

            this.editAssets = false;
            var client = this.client;
            var assets = this.assets;

            var update = Object.keys(assets).reduce((p,key) => { ['showBack','showAvatar'].indexOf(key) == -1 && ( client[key] = p[key] = assets[key] ); return p },{});   
            
            console.log('update client',update);
            if ( client.acctPage_id ) { update.acctPage_id = client.acctPage_id };
            WebSoc.SEND('update',{ DB: 'clients', _id: this.client._id, update: { $set: update } },() => console.log('updated Assets',assets));

        },
        showAssets () {
            this.editAssets = !this.editAssets;

            if ( !this.editAssets ) return;

            this.assets = {
                homeHeader: this.client.homeHeader || false,
                siteTitle: this.client.siteTitle || '',
                siteBrand: this.client.siteBrand || '',
                headerColor: this.client.headerColor || '#FFFFFF',
                headerHeight: this.client.headerHeight || 50,
                headerPadding: this.client.headerPadding || 0,
                headerStrokeWidth: this.client.headerStrokeWidth || 15,
                headerAccentColor: this.client.headerAccentColor || this.eFace.btnColor || this.client.btnColor || '#000000',
                headerBackBevel: this.client.headerBackBevel || false,
                favicon: this.client.favicon || '',
                showBack: false,
                showAvatar: false, 
            };            
        },
        copyPaste ( e ) {
            if ( e.metaKey && ['c','v','x'].indexOf(e.key) > -1 ) {
                var face = this.card.faces.find(face => face.selected);
                if ( !face ) return console.log('!face')
                var btn = face.btns.find(btn => btn.selected);
                    switch ( e.key ) {
                        case 'c':
                            this.copyBtns = btn ? [ btn ] : [];
                        break;
                        case 'v':
                            var btn = this.copyBtns[0];
                                btn.selected = false;
                            var index = face.btns.indexOf(btn);
                                btn = JSON.parse(JSON.stringify(btn));
                                if ( index > -1 ) {
                                    btn.top += 10;
                                    btn.left += 10;
                                }
                                btn.selected = true;
                                face.btns.push(btn);
                                this.updateBtn(btn);
                                this.copyBtns = [ btn ];
                            break;
                        case 'x':
                            if ( !btn ) return;
                            var index = face.btns.indexOf(btn);
                                face.btns.splice(index,1);
                                face.btns[index-1 || 0] && ( face.btns[index-1 || 0].selected = true );                      
                    }


            }
        },
        setHideBoxes ( hideBoxes ) {
            if ( hideBoxes ) {
                this.faces.forEach(face => {
                    face.btns.forEach(btn => btn.selected = false);
                });
            }
        },
        scrollFont ( e ) {

            var boxHeight = parseInt(getComputedStyle(e.target).height);
            var height = parseInt(getComputedStyle(e.target.children[0]).height);
            var children = e.target.children.length
            var scrollTop = e.target.scrollTop;
            if (  scrollTop > ( children * height * 0.3 ) ) {
                this.fontFamilies.filter(f => !f.show).filter((_,i) => i < children).forEach(f => f.show = true);
                this.$forceUpdate();
            }

        }, 
        setScale ( value ) {
            value = parseInt(value);
            this.transformScale = value / 100;
            //console.log('this.transformScale',this.transformScale);
        }, 
        setLoyaltyQty () {
            var qty = parseInt(this.card.loyaltyQty);
            if ( isNaN(qty) ) return console.log('isNaN')
            qty = 'q'+qty;
            var grid = this.loyalGrids[qty];
            if ( !grid ) return console.log('!grid',this.loyalGrids);
            this.faceLoyalty.btns.find(btn => btn.type == 'stamps').grid = grid;
            var front = this.faces[0];
            var btn = front.btns.find(btn => btn.type == 'stamps');
            if ( !btn ) return;
            btn.grid = grid; 
        },
        setReferCard ( referJoinCard ) {
            var faces = this.faces;
            var faceRefer = this.faceRefer;
            if ( referJoinCard ) {
                faceRefer.backgroundColor = this.client.backgroundColor
                faceRefer.btns.forEach(btn => {
                    this.updateBtn(btn);
                });

                faces.indexOf(faceRefer) == -1 && faces.push(faceRefer);
                faces.forEach(face => face.show = true);

                this.selectFace(faceRefer);
                
                if ( faceRefer.btns.length == 1 ) {
                    this.referBtns.forEach(btn => this.addBtn(btn));
                    var back = this.faces[1];
                    this.selectFace(back);
                    var btn = this.types.find(btn => btn.type == 'qr');
                    this.addBtn(btn);
                }

                this.selectBtn(faceRefer,faceRefer.btns[faceRefer.btns.length -1]);
            }
        },
        setLoyaltyCard ( loyaltyCard ) {
            if ( loyaltyCard ) {
                this.faceLoyalty.backgroundColor = this.client.backgroundColor;
                this.setLoyaltyQty();
                this.faceLoyalty.btns.forEach(btn => {
                    this.updateBtn(btn);
                });
                this.faces.indexOf(this.loyaltyCard) == -1 && this.faces.push(this.faceLoyalty);
                this.faces.forEach(face => face.show = true);
                this.selectFace(this.faceLoyalty);

                if ( this.loyaltyBtns.length == 2 ) {
                    this.loyaltyBtns.forEach(btn => this.addBtn(btn));
                    setTimeout(() => {
                        var back = this.faces[1];
                        this.selectFace(back);
                        var btn = this.types.find(btn => btn.type == 'qr');
                        this.addBtn(btn);
                        var btn = this.types.find(btn => btn.type == 'stamps');
                        this.selectFace(this.faces[0]);
                        this.addBtn(btn);
                        this.selectFace(this.faceLoyalty);
                        var btn = this.faceLoyalty.btns.find(btn => btn.type == 'stamps');
                        setTimeout(() => {
                            this.selectBtn(this.faceLoyalty, btn);
                        },100);
                        
                    },100);
                }

            } else {
                this.faces = this.faces.filter(f => f != this.faceLoyalty);
                this.selectFace( this.faces[0]);                
            }
        },
        centerButton ( type, btn ) {
            var width = this.card.width;
            switch ( type ) {
                case 'center':
                    btn.left =  parseInt( ( width - btn.width ) / 2 );
                break;
                case 'center-left':
                    btn.left = parseInt( ( ( width / 2 ) - btn.width ) / 2 );
                break;
                case 'center-right':
                    btn.left = parseInt( ( ( ( width / 2 ) - btn.width ) / 2 ) + ( width * 0.5 ) ); 
                break;
            }
            this.updateBtn( btn );
        },
        cropImage ( face, btn ) {
            if ( btn.type != 'image' ) return;
            var iScale = this.iScale;
            EditImage({
                    src: btn.src,
                    width: btn.width * iScale,
                    height: btn.height * iScale,
                    ratio: NaN
                },result => {
                    btn.width = parseInt(result.width / iScale);
                    btn.height = parseInt(result.height / iScale);
                    btn.src = result.result;
                    this.updateBtn(btn);               
                    postIMG(result.result,resp => {
                        resp.url && ( btn.src = resp.url );
                    });
                })
        },
        startSelection ( e ) {
            if ( !e.target.classList.contains('cards-box') ) return;
            var started = Date.now();
            var body = document.body;
            var cardsBox = this.$el.querySelector('.cards-box');
            var clientX = e.clientX;
            var clientY = e.clientY;
            var width = 0, left = 0, top = 0, left = 0, moving = false, faces = false;
            var div = document.createElement('div');
                div.classList.add('btn-select-container');

                const startMove = () => {
                    var main = div.cloneNode();
                        main.classList.add('main');
                        clientY = top = e.clientY;
                        clientX = left = e.clientX;
                        main.style.top = top + 'px';
                        main.style.left = left + 'px';
                        body.appendChild(moving = main);
                        this.faces.forEach(face => face.btns.forEach(btn => btn.selected = false));
                        this.eFace = this.faces[0];
                }

                const calcFaces = () => {
                    faces = [];
                    var Faces = this.card.faces;
                    faces = [].slice.call(cardsBox.querySelectorAll('.edit-card-box .card-btns')).map((faceBtns,i) => {
                        var FACE = Faces[i];
                        var rect = faceBtns.getBoundingClientRect();
                        return {
                            top: rect.top,
                            left:  rect.left,
                            width: rect.width,
                            height: rect.height,
                            face: FACE,
                            btns: FACE.btns.map(btn => {
                                return {
                                    top: btn.top+rect.top,
                                    bottom: btn.height + btn.top + rect.top,
                                    left: btn.left+ rect.left,
                                    right: btn.width + btn.left + rect.left,
                                    width: btn.width,
                                    height: btn.height,
                                    btn: btn
                                }
                            })
                        }
                    });

                    faces.forEach(face => {
                        var sub = div.cloneNode();
                            face.btns.forEach(btn => {
                                var sub = div.cloneNode();
                                ['top','left','width','height'].forEach(key => sub.style[key] = btn[key]+'px');
                                body.appendChild(btn.sub = sub);
                            })
                    })
                }

                const mouseMove = e => {
                    //if ( Date.now() - start < 500 ) return;
                    !moving && startMove();
                    !faces && calcFaces();
                    var width = ( e.clientX - clientX );
                    var height = ( e.clientY - clientY );
                    var bottom = top + height;
                    var right = left + width;
                    //width > 0 ? ( moving.style.left = clientX + 'px' ) : ( moving.style.left = ( e.clientX + width ) + 'px' );
                    moving.style.width = Math.abs( width ) + 'px';
                    moving.style.height =  Math.abs( height ) + 'px';

                    faces.forEach(face => {
                        face.btns.forEach((btn,i) => {
                            var sub = btn.sub;
                            if ( !sub ) return console.log('!sub',btn);
                            if ( right < btn.left ) return sub.classList.remove('sub-selected'); //return btn.btn.selected = false;
                            if ( btn.bottom < top ) return sub.classList.remove('sub-selected');  //return btn.btn.selected = false;
                            if ( btn.top < top || bottom > btn.top ) return sub.classList.add('sub-selected'); // return btn.btn.selected = true;
                            sub.classList.remove('sub-selected'); //btn.btn.selected = false; 
                        })
                    })
                }

                const mouseUp = e => {
                    
                    moving && document.body.removeChild(moving);
                    document.body.removeEventListener('mouseup',mouseUp);
                    document.body.removeEventListener('mouseleave',mouseUp);
                    document.body.removeEventListener('mousemove',mouseMove);
                    if ( !Array.isArray(faces) ) return;
                    var top = Infinity;
                    var left = Infinity;
                    var right = 0;
                    var height = 0;
                    var count = 0;
                    var Group = {
                        top: Infinity,
                        left: Infinity,
                        right: 0,
                        bottom: 0
                    }
                    var group = faces.map(face => {
                            face.btns = face.btns.filter(btn => {
                                if ( !btn.sub ) return false;
                                body.removeChild(btn.sub);
                                return btn.sub.classList.contains('sub-selected');
                                }).map(btn => {
                                    delete btn.sub;
                                    btn = btn.btn;
                                    Group.top = Math.min(Group.top,btn.top);
                                    Group.left = Math.min(Group.left,btn.left);
                                    Group.bottom = Math.max(Group.bottom,btn.top + btn.height);
                                    Group.right = Math.max(Group.right,btn.left + btn.width);
                                    return btn;
                                });
                        return face;
                    });
                    if ( group[0] ) {
                        console.log('group[0].btns.length',group[0].btns.length)
                        Object.keys(Group).forEach(key => {
                            group[0][key] = Group[key];
                        })
                        console.log('group[0] ??');
                        this.group = group[0];
                        this.eFace = this.group.face;
                        console.log('group',JSON.parse(JSON.stringify(this.group.btns)));
                    }
                }

                document.body.addEventListener('mousemove',mouseMove);
                document.body.addEventListener('mouseleave',mouseUp)
                document.body.addEventListener('mouseup',mouseUp);
        },
        clearSelected ( e ) {
            if ( !e.target.classList.contains('cards-box') ) return;
            this.faces.forEach(face => {
                face.btns.forEach(btn => btn.selected = false);
            })
        },
        confirmExit () {
            Alert.message('Exit Card Design?',yes => {
                if ( !yes ) return;
                this.$router.push(this.editPages ? '/pages' : '/cards');
            });
        },
        getPage ( _id ) {
            
            console.log('getPage',_id);

            var client = this.client;
            
            if ( _id == 'new-page' ) {
                var facePage = this.typeFaces.find(p => p.component == 'CPage');
                this.inherits.forEach(key => {
                    facePage[key] = client[key];
                });
                
                this.card = facePage;
                this.eFace = facePage;
                return;


                this.card.height = facePage.height;
                this.card.title = facePage.title;
                this.faces = [ facePage ];
                this.eFace = facePage;
                this.selectFace(facePage);

            } else {
                this._id = _id;

                var page = this.pages.find(page => page._id == _id);

                !page && WebSoc.SEND('get',{ DB: 'pages', _id: _id },page => {
                    console.log('getPages',page);
                    this.showPage(page);
                    //this.pages.forEach(page => console.log(page._id,page.title));
                    //console.log(JSON.parse(JSON.stringify(page)));
                })
                page && console.log('got page !!',page);
                page && this.showPage(JSON.parse(JSON.stringify(page)));
            }
        },
        getCard ( _id ) {
            
            console.log('getCard',_id)
            console.log('this.client',this.client)

            this._id = _id;

            WebSoc.SEND('get',{ DB: 'cards', _id },card => {
                console.log('getCard',card.title);
                this.addFontFamilies(card.fontFamilies);
                this.card = card;
                card.height = card.height || 500;
                card.width = card.width || 414;
                card.loyaltyCard = card.loyaltyCard || false;
                var front = this.faces[0];
                var back = this.faces[1];
                front.src = card.background;
                front.backgroundColor = card.frontBackgroundColor || this.client.backgroundColor;
                front.fontColor = card.frontFontColor || this.client.fontColor;
                front.btns = card.btns.filter(b => !b.reverse);
                back.src = card.src;
                back.backgroundColor = card.backBackgroundColor || this.client.backgroundColor;
                back.fontColor = card.backFontColor || this.client.fontColor;
                back.btns = card.btns.filter(b => b.reverse);
                back.src || back.btns.length > 0 && ( back.show = true );

                [front,back].forEach(face => {
                    console.log(face == front ? 'front' : 'back');
                    ['backgroundColor','fontColor'].forEach(key => console.log(key,':'+face[key]+':'));
                });

                if ( card.expires > 0 ) {
                    var date = new Date(card.expires);
                    this.hour = adZ(date.getHours());
                    this.minute = adZ(date.getMinutes());
                    this.day = adZ(date.getDate());
                    this.month = adZ(date.getMonth() + 1);
                    this.year = adZ(date.getFullYear() - 2000);
                }

                card.cat = card.cat || 'No Category';
                card.config && ( this.config = card.config );
                //console.log('889 selectFace');
                this.selectFace(front);

                this.currentItem = JSON.stringify(card);

            });

            function adZ(num) { return (num < 9 ? '0' : '')+num }

        },
        editTerms ( btn ) {

            const saveChanges = ( item ) => {
                this.quill = false;
                WebSoc.SEND({ t: 'updateQuill', data: item },(resp) => {
                    if ( resp._id ) { btn.terms_id = resp._id }
                });
            }

            if ( btn.terms_id ) {
                WebSoc.SEND({ t: 'getQuill', data: { _id: btn.terms_id } },quill => {
                    quill.save = saveChanges;
                    this.quill = quill;
                })
            } else {
                this.quill = {
                    save: saveChanges,
                    html: '<p>Edit you page here</p>',
                }
            }

        },
        emitQuill ( data ) {
            switch ( data.action ) {
                case 'exit': return this.quill = false;
            }
            if ( data.HTML ) {
                this.quill.btn.html = data.HTML;
            }
        },
        editQuill ( btn ) {

            const saveChanges = ( item ) => {
                this.quill = false;
                btn.html = item.html;
                item.client_id = this.client_id;
                WebSoc.SEND({ t: 'updateQuill', data: item },(resp) => {
                    if ( resp._id ) { btn.quill_id = resp._id }
                });
            }

            if ( btn.quill_id ) {
                WebSoc.SEND({ t: 'getQuill', data: { _id: btn.quill_id } },quill => {
                    quill.save = saveChanges
                    this.quill = quill;
                    this.quill.btn = btn;
                })
            } else {
                this.quill = {
                    btn: btn,
                    save: saveChanges,
                    html: '<p>Edit you page here</p>',
                }
            }
        },
        getCats () {
            WebSoc.SEND('get',{ DB: 'clients', _id: this.client_id, project: { adCats: 1 } },client => {
                this.card.cat = this.card.cat || 'No Category';
                this.cats = ['No Category'].concat(client.adCats);
            });
        },
        savePage () {
            var card = this.card;
            if ( card.cat == 'No Category' ) { card.cat = '' }
            
            if ( this.client.acctPage_id ) { WebSoc.SEND('update',{ DB: 'clients', _id: this.client._id, update: { $set: { acctPage_id: this.client.acctPage_id }}},() => { console.log('update client.acctPage_id')} )  }

            if ( !card._id ) {
                WebSoc.SEND({ t: 'newPage', data: { page: card } },page => {
                    console.log('page',page);
                })
            } else {
                var currentItem = JSON.parse(this.currentItem);
                var update = Object.keys(card).reduce((p,key) => {
                    if ( JSON.stringify(card[key]) != JSON.stringify(currentItem[key]) ) { p[key] = card[key] }
                    return p;
                },{})
                if ( Object.keys(update).length == 0 ) return console.log('no update');
                WebSoc.SEND('update',{ DB: 'pages', _id: card._id, update: { $set: update }},() => {
                    Alert.message('Committed Update');
                });
            }   

            return console.log('STOP savePage')
            //var client = this.client;
            //var page = this.makePage(this.faces);

            //console.log('client',JSON.parse(JSON.stringify(client)));
            //console.log('page',JSON.parse(JSON.stringify(page)));

            

            if ( page._id ) {
                var currentItem = JSON.parse(this.currentItem);

                var update = Object.keys(page).reduce((p,key) => {
                    if ( JSON.stringify(page[key]) != JSON.stringify(currentItem[key]) ) {
                        p[key] = page[key];
                    }
                    return p;
                },{});
                WebSoc.SEND('update',{ DB: 'pages', _id: page._id, update: { $set: update }},() => console.log('updated page',{ update }));
            }

            if ( !page._id ) {
               
                WebSoc.SEND('newPage',{ page },page => {
                    console.log('newPage page',page)
                }); 

            }


        },
        saveCard () {

            var card = this.card;

            if ( card.cat == 'No Category' ) { card.cat = '' }
            
            if ( this.client.acctPage_id ) { WebSoc.SEND('update',{ DB: 'clients', _id: this.client._id, update: { $set: { acctPage_id: this.client.acctPage_id }}},() => { console.log('update client.acctPage_id')} )  }

            if ( !card._id ) {
                card.client_id = this.client_id;
            
                console.log('saveCard newCard',JSON.parse(JSON.stringify(card)));

                WebSoc.SEND({ t: 'newCard', data: { card: card } },resp => {
                    console.log('newCard resp',JSON.parse(JSON.stringify(resp)));
                    resp.card && this.cards.splice(0,0,resp.card);
                })
            } else {
                var currentItem = JSON.parse(this.currentItem);
                var update = Object.keys(card).reduce((p,key) => {
                    if ( JSON.stringify(card[key]) != JSON.stringify(currentItem[key]) ) { p[key] = card[key] }
                    return p;
                },{})
                if ( Object.keys(update).length == 0 ) return console.log('no update');

                WebSoc.SEND('update',{ DB: 'cards', _id: card._id, update: { $set: update }},() => {
                    Alert.message('Committed Update');
                });
            }   

            return console.log('STOP');



            var card = this.makeCard(faces);
            if ( card.cat == 'No Category' ) { card.cat = '' }

            if ( this._id ) {

                var item = JSON.parse(this.currentItem);
        
                var update = Object.keys(card).reduce((p,key) => {
                    if ( JSON.stringify(card[key]) != JSON.stringify(item[key]) ) p[key] = card[key];
                    return p
                },{});

                this.$router.push('/cards');

                return WebSoc.SEND('update',{ DB: 'cards', _id: this._id, update: { $set: update } },resp => {
                    console.log('updated')
                })
            }

            if ( !this._id ) {
                this.$router.push('/cards');
                delete card._id;
                WebSoc.SEND('newCard',{ card: card },resp => {
                    //console.log('newCard resp',resp);
                    card._id = resp._id;  
                    card.code = resp.code;
                });                
            }
        },
        save () {
            var card = this.card;
            console.log('card.component',card.component);
            if ( card.component == 'CPage' ) {
                if ( !card.title ) return Alert.message('Each Page must have a title');
                return this.savePage()
            }

            if ( card.component == 'CCard' ) {
                if ( !card.title ) return Alert.message('Each Card must have a title');
                return this.saveCard()
            }

            return console.log('STOP');

            if ( this.editPages ) {
                if ( !this.card.title ) 
                return this.savePage(this.faces);
            } else {
                if ( !this.card.title ) return Alert.message('Each Card must have a title');
                return this.saveCard(this.faces);
            }
            
            
           /*
            
            if ( card.cat == 'No Category' ) { card.cat = '' }

            if ( this._id ) {

                var item = JSON.parse(this.currentItem);
        
                var update = Object.keys(card).reduce((p,key) => {
                    if ( JSON.stringify(card[key]) != JSON.stringify(item[key]) ) p[key] = card[key];
                    return p
                },{});

                //console.log('update vs card',update);

                this.$router.push('/cards');

                return WebSoc.SEND('update',{ DB: 'cards', _id: this._id, update: { $set: update } },resp => {
                    console.log('updated')
                })
            }

            if ( !this._id ) {
                this.$router.push('/cards');
                delete card._id;
                WebSoc.SEND('newCard',{ card: card },resp => {
                    //console.log('newCard resp',resp);
                    card._id = resp._id;  
                    card.code = resp.code;
                });                
            }
            */

        },
        checkExpireAd () {
            if ( this.card.expireAd ) {
                this.setExpire = true;
            } else {
                this.card.u_expires = '';
                this.card.expires = false;
            }
        },
        setExpiryDate () {
            this.card.expires = this.expires;
            this.card.u_expires = format(this.expires,'dd/MM/yy HH:mm');
            //console.log('this.card.u_expires',this.card.u_expires);
            this.setExpire = false;
        },
        changeDate () {
            var { hour, minute, day, month, year } = this;
            this.expires = new Date(2000 + parseInt(year),month-1,parseInt(day),parseInt(hour),parseInt(minute)).valueOf();
        },
        copy () {
            this.card.title += ' (copy)';
            this._id = false;
            this.faces.forEach(face => delete face._id);
            var copy = this.$el.querySelector('.view-box');
                copy.classList.add('copy')
                setTimeout(() => {
                    copy.classList.remove('copy');
                },300);

        },
        addFontFamilies ( fontFamilies ) {
            //console.log('addFontFamilies',fontFamilies);
            if ( !Array.isArray(fontFamilies) ) return console.log('addFontFamilies !fontFamilies');
            fontFamilies.forEach(family => {
                this.addFonts(family);
            });
        },
        checkForUpdates ( cB ) {
            var currentItem = this.currentItem
            if ( !currentItem ) return cB();
            var page = this.faces[0];
            currentItem = JSON.parse(currentItem);
            
            console.log('currentItem.title',{ title: currentItem.title, _id: currentItem._id });
            console.log('page.title',{ title: page.title, _id: page._id });

            if ( currentItem._id != page._id ) { console.log('Diff Page ?'); return cB(); }
            
            var update = Object.keys(page).reduce((p,key) => {
                    if ( JSON.stringify(page[key]) != JSON.stringify(currentItem[key]) ) {
                        p[key] = page[key];
                    }
                    return p;
                },{})
            if ( Object.keys(update).length == 0 ) return cB();

            if ( update.btns ) {
                page.btns.forEach((btn,i) => {
                    var current = currentItem.btns[i];
                    Object.keys(btn).forEach(key => {
                        if ( current[key] != btn[key] ) console.log(key,{ 
                            i,
                            current: current[key],
                            newBtn: btn[key]
                        });
                    })
                })
            }
            cB(update);   
        },
        showCard ( card ) {
            if ( !card.newCard ) {
                var newCard = {
                    newCard: true,
                    id: card.id,
                    component: 'CCard',
                    type: 'Card',
                    title: card.title,
                    width: card.width,
                    height: card.height,
                    fontFamilies: card.fontFamilies,
                    faces: [
                        { face: 'front', width: card.width, height: card.height, selected: true, src: card.background, btns: card.btns.filter(b => !b.reverse) },
                        { face: 'back', width: card.width, height: card.height, selected: true, src: card.backface, btns: card.btns.filter(b => b.reverse) }
                    ]
                }
                this.inherits.forEach(key => {
                    newCard.faces.forEach(face => face[key] = this.client[key]);
                });
                newCard.faces.forEach(face => getCodes(face,() => {}));
                this.addFontFamilies(newCard.fontFamilies);
                this.card = newCard;
                this.editPage = true;
                this.selectFace(newCard.faces[0]);
                this.currentItem = JSON.stringify(newCard)
                this.eFace = newCard;
                return newCard;
            } else {
                this.addFontFamilies(card.fontFamilies);
                this.card = card;
                
                this.editPage = true;
                this.selectFace(card.faces[0]);
                this.currentItem = JSON.stringify(card)
                this.eFace = card;
                return card;                
            }
        },
        showPage ( page, checkedForUpdates ) {
            
            console.log('showPage page',JSON.parse(JSON.stringify(page)));

            if ( !checkedForUpdates && this.currentItem ) {
                return this.checkForUpdates(update => {
                    
                    console.log('update',update);

                    if ( !update ) return this.showPage(page,true);
                    var currentItem = JSON.parse(this.currentItem);
                    Alert.yesno('Do you want to save changes to<br>'+ currentItem.title +'?',yes => {
                        if ( yes ) {
                            
                            WebSoc.SEND('update',{ DB: 'pages', _id: page._id, update: { $set: update }},() => console.log('updated'))
                        }
                        this.showPage(page,true);
                    }) 
                })
            }

            if ( !page.newPage ) {

                var face;
                var newPage = {
                    newPage: true,
                    id: page.id,
                    client_id: this.client_id,
                    component: 'CPage',
                    type: 'Page',
                    title: page.title,
                    width: page.width,
                    height: page.height,
                    fontFamilies: page.fontFamilies,
                    faces: [
                        face = {
                         face: 'home',   
                         width: page.width,
                         height: page.height,
                         face: 'page',
                         selected: true,
                         src: page.src,   
                         btns: page.btns,
                         show: true
                        }
                    ]
                }
                
                this.inherits.forEach(key => face[key] = this.client[key]);
                newPage.faces.forEach(face => getCodes(face,() => {}));
                page = newPage;
            }


            this.addFontFamilies(page.fontFamilies);
            this.card = page;
            this.editPage = true;
            this.selectFace(this.card.faces[0]);

            !page._id && ( page.title += ' (NEW)');
            console.log('newPage',JSON.parse(JSON.stringify(page)));
            !page._id && Alert.yesno('Save New Page ?',yes => {
                if ( !yes ) return;
                WebSoc.SEND('newPage',{ page },resp => {
                    console.log('resp newPage',JSON.parse(JSON.stringify(resp.page)));
                    this.pages.push(resp.page);
                    this.makeAppPages(); 
                })
            })
            
            console.log('newPage 2489',JSON.parse(JSON.stringify(page)));

            return page;


            !Array.isArray(page.btns) && console.log('!page.btns',JSON.parse(JSON.stringify(page)));
            this.addFontFamilies(page.fontFamilies);
            this.currentItem = JSON.stringify(page);
            ['height','title'].forEach(key => this.card[key] = page[key]);
            this.card.height = page.height;
            this.card.title = page.title;
            var now = Date.now();
            getCodes(page,() => {
                this.faces = [ page ];
                this.editPages = true;
                this.selectFace(page);
            })
        },
        makePage ( faces ) {
            
            var face = JSON.parse(JSON.stringify(faces[0]));

            var client = this.client;

            var page = this.card;
                    
                page.client_id = this.client_id;
            
                Object.keys(face).forEach(key => {
                    if ( key == 'title' ) return;
                    page[key] = face[key];
                });

            var fonts = face.btns.filter(b => ['text','button'].indexOf(b.type) > -1).reduce((p,btn) => { !p[btn.fontFamily] && p.push(p[btn.fontFamily] = btn.fontFamily); return p },[])
              
                page.fontFamilies = this.fontFamilies.filter(f => fonts.indexOf(f.font) > -1).filter(f => f.href);
                
                delete page.config;

                page.btnsHeight = 0;

                face.btns.forEach(btn => {
                    page.btnsHeight = Math.max(page.btnsHeight,btn.top + btn.height);
                    delete btn.html;
                });

                page.btnsHeight += 500;

                ['bottomless','expireAd','expires','isBottomless','loyaltyCard','loyaltyQty','loyaltyTitle','qtyEntries','qtyMembers','qtyRedeemed','qtySent','redeemAd','rewardJoinCard','rewardTitle','u_expires','siteURL'].forEach(key => {
                    console.log(key,page[key]);
                    delete page[key];
                })

                if ( page.cat == 'No Category' ) { page.cat = '' }
                
                return page;
        },
        makeCard ( faces ) {
            
            var front = faces[0];
            var back = faces[1];
            var page = faces[2];

            var card = this.card;
                card.client_id = card.client_id || this.client_id;
                card.src = front.src || '';
                card.btns = front.btns;
                card.backface = '';
                card.frontBackgroundColor = front.backgroundColor;
                card.backBackgroundColor = back.backgroundColor;
                card.frontFontColor = front.fontColor;
                card.backFontColor = back.fontColor;
               
                ['frontBackgroundColor','backBackgroundColor','frontFontColor','backFontColor'].forEach(key => {
                    console.log('card.'+key,card[key]);
                });

                if ( back.show ) {
                    card.backface = back.src || '';
                    card.btns = card.btns.concat(back.btns.map(b => { b.reverse = true; return b }))
                }

                var fonts = card.btns.filter(b => ['text','button'].indexOf(b.type) > -1).reduce((p,btn) => { !p[btn.fontFamily] && p.push(p[btn.fontFamily] = btn.fontFamily); return p },[])
                    card.fontFamilies = this.fontFamilies.filter(f => fonts.indexOf(f.font) > -1).filter(f => f.href);
                    card.config = this.config;

                card.btns.forEach(btn => {
                    delete btn.html;
                })    

                return card;
            
        },
        preview () {
            var face = this.faces[0];
            if ( ['home','join','page'].indexOf(face.face) > -1 ) return Alert.message('Cannot Preview Pages in Designer yet !');
            this.Card = this.makeCard( this.faces );
        },
        uploadVideo ( btn ) {
            document.querySelectorAll('input#video').forEach(i => i.parentElement.removeChild(i));
            var input = document.createElement('input');
                input.id = 'video';
                input.type = 'file';
                input.setAttribute('accept','video/mp4, video/quicktime, video/mov');
                input.onchange = e => {
                    this.UploadFile(e.target.files[0],url => {
                        //console.log('url',url);
                        btn.mov = url;
                        input.parentElement.removeChild(input);
                    });
                }
                input.style.display = 'none';
                this.$el.appendChild(input);
                input.click();
        },
        UploadFile ( file, cB ) {

            this.setKeyValue({ k: 'progress', v: 0.01 });

            var Bucket = 'trainer-upload';
            //var Bucket = 'cdn.memberstar.club';

                AWS.config.update({
                    accessKeyId: this.aKId,
                    secretAccessKey: this.AK,
                    region: this.region // eu-west-2 LONDON
                });

                var bucket = new AWS.S3({
                        params: {
                            Bucket
                        }
                    });

                var ContentType = file.type.split('/');

                if ( ContentType[1] == 'quicktime' ) ContentType[1] = 'mov';

                //console.log('ContentType',ContentType);

                var ran = new Array(10).fill('abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJLKLMNOPQRSTUVWZXYZ').map(c => c[parseInt(Math.random()* 62)]).join('');
                
                var Key = ran+'-'+Date.now()+'.'+ContentType[1];

                //console.log('begin upload');

                bucket.upload({
                    Key,
                    ContentType: ContentType.join('/'),
                    Body: file,
                    ACL: 'public-read'
                },(e,data) => {
                        if ( e ) console.log('putObject Error',e);
                        this.setKeyValue({ k: 'progress', v: 0 });
                        cB('https://'+Bucket+'.s3.eu-west-2.amazonaws.com/'+Key);
                    }
                ).on('httpUploadProgress',(e) => { 
                    this.setKeyValue({ k: 'progress', v: e.loaded / e.total });
                });
        },
        urlVideo ( btn ) {
            Alert({
                header: 'Add Video URL',
                input: '',
                width: 900
            },url => {
                btn.mov = url
            });
        },
        startMove ( face, btn, e ) {
            var dir = e.target.id;
            this.moving = btn;
            this.eFace = false;
            this.selectBtn(face,btn);
            var clientX = e.clientX;
            var clientY = e.clientY;
            var left = btn.left;
            var top = btn.top;
            var width = btn.width;
            var height = btn.height;            
            var scale = 1;
            var adBox = this.$el.querySelector('.view-box');
            var diag = Math.sqrt((width * width) + ( height * height));
            var ratio = width / height;
            var HEIGHT = face.height || this.card.height;
            const mouseMove = e => {
                if ( !this.moving ) return; 
                e.preventDefault();

                var Top = btn.top;
                var Left = btn.left;
                var Width = btn.width;
                var Height = btn.height;

                switch ( dir ) {
                    case 'ne':
                        var Height = height - ( ( ( e.clientY ) - clientY ) / scale );
                        var Top = top + ( ( ( e.clientY ) - clientY ) / scale );  
                        //var Width = width + ( ( ( e.clientX ) - clientX ) / scale );
                        var Width = Height * ratio;
                    break;
                    case 'nw':
                        var Height = height - ( ( ( e.clientY ) - clientY ) / scale );
                        var Top = top + ( ( ( e.clientY ) - clientY ) / scale );  
                        //var Width = width - ( ( ( e.clientX ) - clientX ) / scale );
                        var Width = Height * ratio;
                        var Left = left + ( ( ( e.clientX ) - clientX ) / scale );               
                    break;
                    case 'se':
                        //var Height = height + ( ( ( e.clientY ) - clientY ) / scale );
                        //var Width = Height * ratio;
                        var Width = width + ( ( ( e.clientX ) - clientX ) / scale );
                        var Height = Width / ratio;
                    break;                        
                    case 'sw':
                        //var Height = height + ( ( ( e.clientY ) - clientY ) / scale );  
                        var Width = width - ( ( ( e.clientX ) - clientX ) / scale );
                        var Height = Width / ratio;
                        var Left = left + ( ( ( e.clientX ) - clientX ) / scale );                      
                    break;
                    case 'n':
                        var Height = height - ( ( ( e.clientY ) - clientY ) / scale );
                        var Top = top + ( ( ( e.clientY ) - clientY ) / scale );
                    break;                        
                    case 'e':
                        var Width = width + ( ( ( e.clientX ) - clientX ) / scale );
                    break;
                    case 's':
                        var Height = height + ( ( ( e.clientY ) - clientY ) / scale );
                    break;
                    case 'w':
                        var Width = width - ( ( ( e.clientX ) - clientX ) / scale );
                        var Left = left + ( ( ( e.clientX ) - clientX ) / scale );
                    break;
                    default:
                        var Left = left + ( ( ( e.clientX ) - clientX ) / scale );
                        var Top = top + ( ( ( e.clientY ) - clientY ) / scale );
                } 
                
                if ( Top < 0 ) Top = 0;
                if ( Top + Height > HEIGHT ) { 
                    Top = HEIGHT - Height 
                }
                btn.top = parseInt(Top);
                btn.width = parseInt(Width);
                btn.height = parseInt(Height);
                if ( Left < 0 ) Left = 0;
                if ( Left + Width > 412 ) { Left = 412 - Width }
                Left = Math.max(0,Left);
                btn.left = parseInt(Left);
                this.updateBtn(btn);
            }

            const mouseUp = e => {
                e.stopPropagation();
                e.preventDefault();
                adBox.removeEventListener('mouseleave',mouseUp);
                adBox.removeEventListener('mouseup',mouseUp);
                this.$el.removeEventListener('mousemove',mouseMove);
                setTimeout(() => {
                    this.moving = false;
                },0);
            }
           

            adBox.addEventListener('mouseleave',mouseUp);
            adBox.addEventListener('mouseup',mouseUp);
            this.$el.addEventListener('mousemove',mouseMove);
        },
        removeBtn ( face, btn ) {
            console.log('removeBtn',{ face, btn });
            try {
            var index = face.btns.indexOf(btn);
            face.btns = face.btns.filter(b => b != btn);
            var btn = face.btns[index] || face.btns[face.btns.length-1] || {};
                btn.selected = true;
            } catch(e) {
                console.log(e);
            }
        },
        removeFace ( face ) {
            var index = this.card.faces.indexOf(face);
            if ( face.faceLoyalty ) {
                this.card.loyaltyCard = false;
            }
            if ( face.faceRefer ) {
                this.card.rewardJoinCard = false;
            }
            face.show = false;
            if ( this.card.faces[index -1] && this.card.faces[index -1].show ) {
                this.selectFace(this.card.faces[index -1])
            } else {
                this.selectFace(this.card.faces[0]);
            }
        },
        addBackground ( force ) {

            var face = this.eFace;
            if ( !face ) face = this.faces[0];

            //console.log('addBackground',{ 
            //    force,
            //    face
            //});
            var iScale = this.iScale;

            var { width, height } = face;

            console.log({
                width,
                height
            });

            var size = { width, height, ratio: width / height };

            console.log({ size });

            face.selected = true;

            if ( face.src && !force ) {
                return Alert.yesno('Do you want to remove this background',yes => {
                    if ( yes ) return face.src = '';
                    this.addBackground(true);
                });
            }

            UploadFile(result => {

                var i = document.createElement('img');
                    i.onload = () => {
                        console.log({
                            width: i.width,
                            height: i.height
                        });
                        if ( (i.width / i.height).toFixed(2) == size.ratio.toFixed(2) ) return saveImg(result);       
                        editIMG(i.src);   
                    }
                    i.src = result.result;    
                    /*
                    face.src = result.result;
                    //this.setKeyValue({ k: 'progress', v: 0.01 });
                    postIMG(result.result,resp => {
                        if ( resp.size ) return console.log('resp.size',resp.size);
                        //if ( resp.progress ) { this.setKeyValue({ k: 'progress', v: ( resp.progress.progress / resp.progress.total ) * 0.8 }) }
                        if ( resp.url ) {
                            //this.setKeyValue({ k: 'progress', v: 0 });
                            face.src = resp.url;
                        }
                    })
                    */
                })

                const saveImg = result => {
                    face.src = result.result;
                    postIMG(result.result,resp => {
                        if ( resp.url ) {
                            face.src = resp.url;
                        }
                    })                   
                }

                const editIMG = dataURL => {
                    EditImage({
                        src: dataURL,
                        width: size.width * iScale,
                        height: size.height * iScale,
                        ratio: size.ratio
                    },result => {
                        face.src = result.result;              
                        postIMG(result.result,resp => {
                            resp.url && ( face.src = resp.url );
                        });
                    })
                }


       
        },
        addButtonImage ( face, btn ) {

            var { width, height } = btn;
            var ratio = width / height;
            
            this.addImage(face,btn,i => {
                if ( ( i.width / i.height ).toFixed(2) != ratio.toFixed(2) ) {  
                    EditImage({
                        src: i.src,
                        width: btn.width * this.iScale,
                        height: btn.height * this.iScale,
                        ratio: ratio
                    },result => {
                        btn.width = parseInt(result.width / this.iScale);
                        btn.height = parseInt(result.height / this.iScale);
                        btn.image = result.result;
                        btn.textAlign = 'left';
                        this.updateBtn(btn);               
                        postIMG(result.result,resp => {
                            resp.url && ( btn.image = resp.url );
                        
                        });
                    });
                } else {
                    btn.image = i.src;
                    btn.textAlign = 'left';
                    postIMG(i.src,resp => {
                        resp.url && ( btn.image = resp.url );
                    })
                }
            })
        },
        replaceImage ( face, btn ) {
            var iScale = this.iScale;
            this.addImage(face,btn,i => {
                var currentRatio = (btn.width / btn.height).toFixed(2)
                var newRatio = (i.width / i.height).toFixed(2);
                if ( newRatio != currentRatio ) {
                    return EditImage({
                        src: i.src,
                        width: btn.width * iScale,
                        height: btn.height * iScale,
                        ratio: currentRatio
                    },result => {
                        btn.width = parseInt(result.width / iScale);
                        btn.height = parseInt(result.height / iScale);
                        btn.src = result.result;
                        this.updateBtn(btn);               
                        postIMG(result.result,resp => {
                            resp.url && ( btn.src = resp.url );
                        });
                    });
                } else {
                    btn.src = i.src;
                    postIMG(i.src,resp => {
                        resp.url && ( btn.src = resp.url );
                    })
                }
            });
        },
        addLoyaltyImage ( type ) {
            console.log({ type });
            var card = this.card;
            var assets = this.assets;

            var LU = {
                siteBrand: { width: 200, height: 150, ratio: NaN },
                avatar: { width: 75, height: 75, ratio: 75 / 75 },
                headerPlain: { width: 828, height: 153, ratio: 828 / 153 },
                headerBack: {  width: 828, height: 153, ratio: 828 / 153 },
                loyaltyPlain: { width: 250, height: 250, ratio: 250 / 250, stamps: true },
                loyaltyStamp: { width: 250, height: 250, ratio: 250 / 250, stamps: true }
            }
            var size = LU[type];

            UploadFile(result => {
                if ( type == 'favicon' ) return saveLoyalty(result);
                var i = document.createElement('img');
                    i.onload = () => {
                        console.log({
                            width: i.width,
                            height: i.height
                        });
                        if ( (i.width / i.height).toFixed(2) == size.ratio.toFixed(2) ) return saveLoyalty(result);       
                        editLoyalty(i);   
                    }
                    i.src = result.result;                
            });

            const editLoyalty = img => {

                EditImage({
                    src: img.src,
                    width: size.width,
                    height: size.height,
                    ratio: size.ratio
                },result => {            
                    saveLoyalty(result);
                })
            }

            const $set = url => {
                if ( ['siteBrand'].indexOf(type) > -1 ) {
                    this.$set(assets,type,url)
                } else {
                    this.$set(card,type,url);
                }
            }

            const saveLoyalty = result => {

                $set(result.result);

                //this.$set(type == 'headerPlain' ? assets : card,type,result.result);                
                
                //this.$forceUpdate();
                postIMG(result.result,resp => {
                    if ( resp.url ) {

                        //this.$set(type == 'headerPlain' ? assets : card,type,resp.url);    
                        
                        $set(resp.url);
                        
                        if ( LU.stamps ) {
                            this.$set(this.faceLoyalty.btns.find(btn => btn.type == 'stamps'),type,resp.url);
                            this.$set(this.faces[0].btns.find(btn => btn.type == 'stamps'),type,resp.url);
                        }
                    }
                });
            } 
        },
        addImage ( face, btn, cB ) {
            return UploadFile(result => {
                        //this.setKeyValue({ k: 'progress', v: 0.01 });
                        var i = document.createElement('img');
                            i.onload = () => {
                                if ( typeof cB == 'function' ) return cB(i);
                                btn.height = parseInt(( 414 / i.width ) * i.height);
                                this.updateBtn(btn);
                                face.btns.push(btn);
                                this.selectBtn(face,btn);                            
                            }
                            i.src = result.result;

                            if ( typeof cB == 'function' ) return;

                            btn.src = result.result;
                            
                            postIMG(result.result,resp => {

                                //if ( resp.progress ) { this.setKeyValue({ k: 'progress', v: ( resp.progress.progress / resp.progress.total ) * 0.8 }) }
                                
                                if ( resp.url ) {
                                    btn.src = resp.url;
                                    //this.setKeyValue({ k: 'progress', v: 1 });
                                    setTimeout(() => {
                                        //this.setKeyValue({ k: 'progress', v: 0 });
                                    },50);
                                    
                                } 

                            })
                    })
        },
        setColor ( field, value ) {
            switch ( field ) {
                case 'backgroundColor':
                case 'fontColor':
                    return this.card.faces.forEach(face => {
                        face[field] = value;
                        face.btns.filter(b => b.type == 'text').forEach(btn => btn[field] = value);
                    });
                case 'btnColor': 
                case 'btnFontColor':
                case 'borderColor':
                case 'borderWidth':
                return this.card.faces.forEach(face => {
                        face.btns.filter(btn => btn.type == 'button').forEach(btn => {
                            btn[field] = value;
                        })
                    });                  
            }
            console.log('setColor what with',{ field,value })

        },
        addBtnDrag ( type, e ) {
            var btn = JSON.parse(JSON.stringify(type));
            this.movingBtn = btn;
            var startX = e.clientX;
            var startY = e.clientY;
            var target = e.target;
            var mover;
            var faces;

            const calcFaces = () => {
                faces = [];
                var Faces = this.card.faces;
                faces = [].slice.call(this.$el.querySelectorAll('.card-container')).map((faceBtns,i) => {
                    var FACE = Faces[i];
                    var rect = faceBtns.getBoundingClientRect();
                    return {
                        top: rect.top - 5,
                        left:  rect.left - 5,
                        width: rect.width, //+ 10,
                        height: rect.height + 10,
                        btnsBox: faceBtns,
                        face: FACE,
                        btns: FACE.btns.map(btn => {
                            return {
                                top: btn.top+rect.top,
                                bottom: btn.height + btn.top + rect.top,
                                left: btn.left+ rect.left,
                                right: btn.width + btn.left + rect.left,
                                width: btn.width,
                                height: btn.height,
                                btn: btn
                            }
                        })
                    }
                }); 
            }

            const mouseMove = ( e ) => {
                e.preventDefault();
                var x = e.clientX - startX;
                var y = e.clientY - startY;
                if ( x < 10 && x < 10 ) return;
                if ( !mover ) {
                    while ( !target.classList.contains('app-nav-button') ) { target = target.parentElement; }
                    var rect = target.getBoundingClientRect();
                        mover = this.$el.querySelector('.mover-svg .svg-container').cloneNode(true);
                        mover.classList.add('btn-dropper');
                        mover.style.left = rect.left +'px'
                        mover.style.top = rect.top+'px';
                        mover.setAttribute('m-type',btn.type);
                        document.body.appendChild(mover);
                        
                        setTimeout(() => {
                            calcFaces();
                            /*
                            faces.forEach(face => {
                                var div = document.createElement('div');
                                    div.style.position = 'fixed';
                                    div.style.border = '5px solid red';
                                    ['width','height','top','left'].forEach(key => div.style[key] = face[key]+'px');
                                    document.body.appendChild(div);
                            })
                            */
                        },500);
                        
                }
                mover.style.transform = 'translate('+x+'px,'+y+'px)';
            }

            const mouseUp = ( e ) => {
            
                document.body.removeEventListener('mouseup',mouseUp);
                document.body.removeEventListener('mousemove',mouseMove);
                if ( !mover || !mover.parentElement ) return;
                faces.forEach((face,i) => {
                    if ( 
                        e.clientX > face.left && e.clientX < face.left + face.width
                    &&  e.clientY > face.top && e.clientY < face.top + face.height
                    ) {                       
                        btn.top = e.clientY - ( face.top + 70 ); btn.left = e.clientX - ( face.left + 5 );  
                        faces.forEach(f => f.face.selected = f == face);
                        this.addBtn( type, btn );         
                    }
                })
                mover && mover.parentElement && document.body.removeChild(mover);
            }

            document.body.addEventListener('mouseup',mouseUp);
            document.body.addEventListener('mousemove',mouseMove);
            document.body.addEventListener('mouseleave',mouseUp);

        },
        addBtn ( type, Btn ) {
            
            var config = this.config;
            var client = this.client;

            var btn = Btn || JSON.parse(JSON.stringify(type));

            /*
            if ( btn.component_id ) {
                var component = this.components.find(c => c._id == btn.component_id);
                if ( !component ) {
                    return WebSoc.SEND('get',{ DB: 'components', _id: btn.component_id },component => {
                        if ( btn.component ) { component.component = btn.component }
                        console.log('btn.component',component.component);
                        this.components.push(component);
                        console.log('component',JSON.parse(JSON.stringify(component)));
                        this.addBtn(component);
                    })
                }
                btn = JSON.parse(JSON.stringify(component));
                console.log('')
            }
            */

                btn.cHeight = false;
                btn.cWidth = false;
                btn.crWidth = false;
                btn.clWidth = false;
           
                
            if ( ['text','button','input'].indexOf(btn.type) > -1 ) {

                this.inherits.forEach(key => {
                    btn[key] = client[key];
                });
                this.selectedFont && ( btn.fontFamily = this.selectedFont );
                this.updateFont(btn);
            }
            var face = this.card.faces.find(f => f.selected);
            if ( !face ) {
                face = this.card.faces[0];
                face.selected = true;
            }
            if ( ['quill','wallet'].indexOf(btn.type) > -1 ) {
                var client = this.client;
                btn.height = face.height - ( ( face.face == 'page' || client.homeHeader )  ? client.headerHeight : 0);
                console.log('face.height',face.height);
                console.log('client.headerHeight',client.headerHeight);
                
                
                console.log('height',btn.height);
            }



            //console.log('type.type',type.type);
            //console.log('btn',btn);
            if ( type.type == 'stamps' ) {
                //console.log('isStamps');
                var lBtn = this.faceLoyalty.btns.find(btn => btn.type == 'stamps');
                //console.log('lBtn',lBtn);
                btn.loyaltyPlain = lBtn.loyaltyPlain;
                btn.loyaltyStamp = lBtn.loyaltyStamp;
                btn.grid = this.loyalGrids['q'+this.card.loyaltyQty] || [];
                //console.log('this.loyaltyQty',this.card.loyaltyQty);
                //console.log('btn',JSON.parse(JSON.stringify(btn)));
            }

            if ( type.type == 'image' ) return this.addImage(face,btn);
            if ( !Btn ) {
                var top = face.btns.reduce((top,btn) => {  if ( btn.top + btn.height > top ) { top = btn.top + btn.height; }; return top; },0);
                btn.top = top + ( top > 0  ? 5 : 0 );
            }
            this.updateBtn(btn);
            face.btns.push(btn);
            face.btns.sort((_,b) => ['rotate','link','buy','event','terms','comp'].indexOf(b.type) ? 1 : -1);
            this.selectBtn(face,btn);

        },
        selectFace ( face ) {
            //console.log('selectFace',face.face);
            !face.selected && this.faces.forEach(f => f.selected = f == face);
            this.eFace = face;
            //this.faces.forEach(face => console.log('face.face',face.face,face.selected));
        },
        addFace ( card ) {
            var current = card.faces[card.faces.length - 1];
            var toAdd = JSON.parse(JSON.stringify(current));
                toAdd.btns = [];
                card.faces.push(toAdd);
        },
        addBack () {
                var face = this.faces[1];
                    face.backgroundColor = this.faces[0].backgroundColor;
                    face.show = true;
                    this.selectFace( face )
        },
        removeBack () {
            this.faces.forEach((f,i) => { f.show = i == 0; })
            this.selectFace( this.faces[0] );
        },
        selectBtn ( face, btn, e ) {
            this.eFace = false;
            this.card.faces.forEach(f => { 
                f.selected = f == face
                f.btns.forEach(b => b.selected = b == btn);
            });
            if ( !e ) return;
            e.stopPropagation();
            e.preventDefault();
            //this.faces.forEach(f => f.selected = f == face);
        },
        setBtnSubmit ( btn, e ) {
            var submitForm = e.target.value;
            if ( submitForm == 'Group' ) return Alert.message('You must name a group to submit it');
            this.$set(btn,'submitForm',e.target.value);
        },
        setBtnValue ({ btn, value }) {
            btn.value = value;
        },
        updateBtn ( btn , e ) {
            var id = e && e.target.id;
            var dir = e && [40,38].indexOf(e.keyCode);

            //console.log('updateBtn',id,(e && e.target.value || ''));

            if ( dir > -1 ) {
                e.preventDefault();
                if ( dir == 0 ) dir = -1;
                if ( !id ) return console.log('!target.id',e.target);
                if ( ['opacity','lineHeight'].indexOf(id) > -1 ) {
                    btn[id] = parseFloat(parseFloat(btn[id] + (dir / 10)).toFixed(1));
                } else {
                    btn[id] += dir;
                }

            }

            if ( id == 'inputWidth' ) {
                var face = this.faces.find(face => face.selected);
                    btn.width = face.width * ( 1 / e.target.innerHTML.split('/').pop())
            }

            if ( id == 'size' ) {
               btn.width = btn.size;
               btn.left = parseInt(( 414  - btn.size ) / 2);
            }

            if ( typeof btn[id] == 'undefined' ) {
                if ( id == 'undefined' ) return console.log('btn[id]',id,'is undefined')
                console.log('btn[id] == undefined',id,btn,e && e.target);
                this.$set(btn,id,( e && e.target.value || '' ));
            }

            if ( id == 'borderWidth' ) {

            }

            var borderWidth = btn.borderWidth * 2;

            if ( btn.type == 'group' ) {
                btn.style = ['top','left','width','height'].map(f => f+':'+btn[f]+'px').join(';')+';';
                btn.style += 'font-size:'+btn.fontSize+'px;';
                btn.style += 'color:'+btn.fontColor;
            } else if ( btn.type == 'button' && borderWidth > 0 ) {
                var { height, width, top, left } = btn;
                height += borderWidth;
                width += borderWidth;
                top -= borderWidth;
                left -= borderWidth;
                btn.style = ['top:'+top,'left:'+left,'width:'+width,'height:'+height].join('px;')+'px';
            } else {
                btn.style = ['top','left','width','height'].map(f => f+':'+btn[f]+'px').join(';')+';';
            }

            //btn.style = btn.style += ['top','left','width','height'].map(f => f+':'+btn[f]+'px').join(';')+';';

            btn.style += btn.bold ? 'font-weight:bold;' : '';

            btn.style += btn.italic ? 'font-style:italic;' : '';

            btn.style += btn.fontWeight ? ('font-weight:'+btn.fontWeight+';') : '';
            
            var { left, top, width, height } = btn;

            var Width = this.card.width;

            var Height = this.card.height;
            
            btn.cHeight = Math.abs( parseInt(Height / 2) - parseInt( top + ( height / 2 ) ) ) < 2;
            btn.cWidth = Math.abs( parseInt(Width / 2) - parseInt( left + (width / 2) ) ) < 2;
            btn.clWidth = Math.abs( parseInt(Width / 4 ) - parseInt( left + ( width / 2 ) ) ) < 2;
            btn.crWidth = Math.abs( parseInt(Width / ( 4 / 3 ) ) - parseInt( left + ( width / 2 ) ) ) < 2;
            /*
            clearTimeout(this._updateBtn);

            this._updateBtn = setTimeout(() => {
                //localStorage.faces = JSON.stringify(this.faces)
                //localStorage.card = JSON.stringify(this.card)
                console.log('saved Design ??');
            },10000)

            */

        },
        updateDefault ( btn, e ) {
            var id = e.target.id;
            if ( typeof this.config[id] == 'undefined' ) return;
            this.config[id] = btn[id];
        },
        moveBtn ( face, btn, dir ) {
            var index = face.btns.indexOf(btn);
            face.btns.splice(index,1);
            face.btns.splice(index+dir,0,btn);
        },
        addFonts ( family ) {

            const addFont = family => {
                family.css = ".font-"+(family.font.replace(/ /g,'').toLowerCase())+"{font-family:'"+family.font+"'}"
                var id = 'font-'+family.font.replace(/ /g,'');
                
                if ( !family.href ) return;

                if ( ['Poppins'].indexOf(family.font) > -1 ) {

                    var href = family.href;

                    switch ( family.font ) {
                        case "Poppins":
                            href += ":ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap";
                        break;
                    }

                    this.addHead({
                        id: id,
                        t: 'link',
                        href,
                        rel: 'stylesheet'                        
                    })
                    
                } else {

                    this.addHead({
                        id: id,
                        t: 'link',
                        href: family.href+'&display=swap',
                        rel: 'stylesheet' 
                    });

                }


            
                if ( document.head.querySelector('style#'+id) ) return; // console.log('got style');
                var style = document.createElement('style');
                    style.id = id;
                    style.innerHTML = ".font-"+(family.font.replace(/ /g,'').toLowerCase())+"{font-family:'"+family.font+"'}";
                    document.head.appendChild(style);
                    //console.log('added font style',family.font);
            };

            if ( family ) return addFont(family);

            this.fontFamilies.forEach(family => addFont(family));
        },
        startShowFocus ( e ) {

            e.target.value = '';
            
            var fontFamilies = this.fontFamilies;

            Object.keys(this.client.fonts || {}).reduce((p,font_id) => {
                var font = fontFamilies.find(f => f._id == font_id);
                if ( !font ) return p;
                font.date = this.client.fonts[font_id];
                p.push(font);
                return p;
            },[]).sort((a,b) => a.date < b.date ? -1 : 1).forEach(font => {
                console.log(font.font,new Date(font.date));
                fontFamilies.splice(fontFamilies.indexOf(font),1);
                fontFamilies.splice(0,0,font);
            });
  
            this.showFontSearch = true
        },
        stopShowFontSearch () {
            setTimeout(() => {
                this.showFontSearch = false;
            },250);
        },
        filterFonts ( action, e ) {
            if ( action == 'keydown' ) return;
            var value = e.target.value;
            if ( !value ) return this.fontFamilies.forEach((family,i) => family.show = i < 50);
            var text = new RegExp(value.split('').join(' *'),'i');
            this.fontFamilies.forEach(family => { 
                family.selected = text.test(family.font) 
            });
        },
        showFontInput ( e ) {
            this.selectedFontFamily = false;
        },
        selectFontFamily ( font, e ) {
            if ( e.metaKey && e.shiftKey ) {
                return Alert.yesno('Delete '+font.font+'?',yes => {
                    WebSoc.SEND('delete',{ DB: 'google-fonts', _id: font._id },resp => {
                        //console.log('deleted',font._id);
                        this.fontFamilies = this.fontFamilies.filter(f => f != font);
                    })
                })
            } 
            this.$el.querySelector('.font-select-input').value = font.font;
            this.selectedFont = font.font;
            this.selectedFontFamily = font;
            console.log('selectFontFamily font',JSON.parse(JSON.stringify(font)));
            this.showFontSearch = false;
            var face = this.faces.find(f => f.selected);
            if ( !face ) return;
            var btn = face.btns.find(b => b.selected);
            if ( !btn ) return;
            btn.fontFamily = font.font;
            this.updateFont(btn);
            this.client.fonts = this.client.fonts || {};
            //console.log('this.client',this.client);
            if ( face.face == 'home' ) {
                WebSoc.SEND('update',{ DB: 'clients', _id: this.client._id, update: { $set: { selectedFont_id: font._id } }},resp => {
                    console.log('updated client.selectedFont_id',font._id);
                })
            }
            if ( !this.client.fonts[font._id] ) {
                WebSoc.SEND('update',{ DB: 'clients', _id: this.client._id, update: { $set: { ['fonts.'+font._id]: Date.now() } }},resp => {
                    console.log('updated font',resp);
                })
            }
            
        },
        updateFont ( btn ) {
            var font = this.fontFamilies.find(font => font.font == btn.fontFamily);
            if ( !font ) return console.log('!font btn.fontFamily',btn.fontFamily);
                btn.css = 'font-'+(font.font.replace(/ /g,'').toLowerCase());
                //console.log('updateFont',{ href: font.href });
                this.addFonts( font );
        },
        ...mapActions([
            'addHead'
        ]),
        ...mapMutations([
            'setKeyValue'
        ])
    }
}

</script>

<style lang="scss">
.btn-dropper {
    position: fixed;
    padding: 5px;
    p {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        margin-top: 5px !important;
    }
}    
.app-nav-button {
    background-color: rgba(67, 76, 90, 0.8);
    margin: 5px 5px 0px 0px;
    .app-nav-button-icon {
        width: 50px;
        height: 50px;
        margin: calc(50% - 25px);
        border: 1px solid #c0c0c0;
    }
    .app-nav-button-title {
        color: white;
        font-size: 13px;
        text-align: center;
        margin-top: -6px;
        padding-bottom: 3px;
    }
}
.app-nav-buttons {
    float: left;
    width: 212px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
}    
.top-left {
    width: 250px;
    display: flex;
}    
.app-page-container {
    width: 200px;
    position: absolute;
    top: 55px;
    .app-nav {
        width: 210px;
        border: 1px solid #c0c0c0;
        float: left;
        display: flex;
        justify-content: space-between;
        p { font-size: 13px; }
        p.selected { font-weight: bold; }
        > div {
            background-color: rgba(255,0,0,0.3);
            p { font-size: 13px; }
        }
    }
    .app-pages {
        float: left;
        width: 100%;
    }
    .app-page-title { 
        width: 100%; float: left; font-size: 13px;
        &.selected { font-weight: bold; }
    }
    .app-btns {
        font-size: 13px;
        &.selected { font-weight: bold; }
    }
    .app-pages-draft {
        font-size: 13px;
        margin: 5px 0px;
        float: left;
        text-decoration: underline;
    }
    .sub-0 {
        .app-btns {
            float: left;
            margin-left: 2px;
            width: calc(100% - 2px);           
        }
    }
    .sub-1 {
        float: left;
        margin-left: 10px;
        width: calc(100% - 10px);
        .app-btns {
            float: left;
            margin-left: 12px;
            width: calc(100% - 12px);
        }
    }
    .sub-2 {
        float: left;
        margin-left: 20px;
        width: calc(100% - 20px);
        .app-btns {
            float: left;
            margin-left: 22px;
            width: calc(100% - 22px);
        }
    }
}    

.v-modal {
  padding-bottom: 40px;
  width: 800px;
  min-height: 100px;
  border:1px solid #c0c0c0;
  top: 100px;
  position: absolute;
  margin-left: calc(50% - 400px);
  float: left;
  background-color: white;
  z-index: 500;
  .content-box {
      overflow: hidden;
      height: calc(100% - 83px);
  }
  .help-text {
      margin: 20px;
      text-align: center;
      font-weight: bold;
  }
  .btns {
        width: 100%;
        border-top: 1px solid #c0c0c0;  
        float: left; 
        position: absolute;
        bottom: 0px; 
        p.btn:last-child { float: right; }
        p.btn {
        font-size: 15px;
        line-height: 2;
        width: 120px;
        text-align: center;
        margin: 5px;
        float: left;
        background-color: rgb(0, 123, 200);
        color: white;
        &.del {
            background-color: rgba(0,0,0,0);
            color: red;
            text-decoration: underline;
        }
        }
    }

    .label {
        width: calc(100% - 46px);
        float: left;
        margin: 10px 10px 20px 10px;
        &.w-50 { width: calc(50% - 23px); min-width: 200px; }
        p { font-size: 13px; margin: 0px 0px 0px 4px; }
        input { float: right; width: 100%; margin: 0px 0px 0px 0px; float: left; font-size: 18px; padding: 3px; }
    } 
} 

.color-group {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-around;
    + .quest {
        position: absolute;
        top: 0px;
        right: -5px;
        top: -20px;
        transform: scale(0.5)
    }
}
.quest {
    width: 30px;
    height: 30px;
    background-color: white;
    border-radius: 50%;
    border: 2px solid rgba(200, 200, 200, 0.8);
    display: flex;
    justify-content: space-around;
    align-items: center;
    &:after {
        content: '?';
        font-size: 25px;
        margin-top: 2px;
    }
}
.page-colors {
    color: white;
    font-size: 0.8em;
    text-align:center;
    margin-bottom: -4px;
}
.color-box {
        width: 30px;
        height: 30px;
        position: relative;
        border: 2px solid rgba(200, 200, 200, 0.8);
        border-radius: 10px;
        input[type=color] { width: 100%; height: 100%; opacity: 0; }
        > p { color: white; position: absolute; font-size: 10px; top: 35px; left: -20px; text-align: center; width: 70px; }
        input:not([type=color]) { width: 80px; position: absolute; }
    }
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.snow.css';
.card-designer .view-box .card-container .edit-card-box .card-btns .card-btn .group-box.ad-btn .ad-btn { background-color: rgba(0,0,0,0); } 
.btn-select-container {
    position: fixed;
    border: 1px solid rgba(0,149,255,1);
    background-color: rgba(0,149,255,0.1);
    display: none; 
    &.main {
        display: inline;
    }
    &.sub-selected {
        display: inline;
        background-color: rgba(0,0,0,0);
        border-color: red;
    }
}
.view-box {
    .label {
        float: left;
        width: 90px;
        
        > input { width: 100%; padding: 3px;font-size: 20px; margin-bottom: 10px; }
        > select { width: calc(100% - 0px); }
        > p { font-size: 12px; text-transform: capitalize; font-weight: bold; }
    }
    &.hide-boxes {
        .edit-card-box {
            .card-btns {
                .card-btn {
                    .ad-btn {
                        background-color: rgba(0,0,0,0) !important;
                    }
                }
            }
        }
    }
}    
.faces-box {
    position: relative;
    top: 5px;
    left: 5px;
    z-index: 100;

    .face-box-type {
        position: relative;
        left: 15px;
        padding-right: 0px;
        width: 200px;
        &:before {
            content: '- '
        }
    }
    .face-box-face {
        float: left;
    }
}    
.x.fixed-scroller-x {
    &:before,&:after {
        background-color: white;
    }
}    
.arrow {
    background-image: url('/arrow.png');
    background-size: contain;
    width: 25px;
    height: 25px;
    background-color: white;
    &.down {
        transform: rotate(180deg);
    }

}  
.cross {
    background-image: url('/cross.png');
    background-size: contain;
    width: 25px;
    height: 25px;
    background-color: white;
}  
.font-select {
    input + div {
        border: 1px solid rgb(192, 192, 192);
        border-bottom: 0px;
        position: absolute;
        top: 33px;
        left: 5px; 
        max-height: calc(100vh - 80px);
        overflow-y: scroll;       
    }
}
.plus {
    width: 20px;
    height: 20px;
    float: right;
    position: relative;
    &.minus {
        &:after {
            display: none;
        }
    }
    &:before {
        position: absolute;
        top: 9px;
        left: 2px;
        content: '';
        width: 17px;
        height: 2px;
        background-color: black;
    }
    &:after {
        position: absolute;
        top: 9px;
        left: 2px;
        content: '';
        width: 17px;
        height: 2px;
        background-color: black;
        transform: rotate(90deg);
    }
}
.card-designer {
    float: left;
    width: 100%;
    height: calc(100vh - 50px);
    position: fixed;
    top: 50px;
    .top-nav {
        width: calc(100% - 300px);
        position: fixed;
        top: 50px;
        left: 0px;
        height: 42px;
        background-color: whitesmoke;
        border-bottom: 1px solid rgba(67,76,90,0.8);
        .top-item {
            float: left;
            p.btn.sm {
                width: 80px;
                font-size: 13px;
                margin-top: 10px;
                margin-right: 0px;
            }
            &.label {
                margin-top: 1px;
                * { float: left; }
                p { margin: 10px; }

                input { font-size: 20px; margin: 5px; width: 90px; }
            }
        }
    }
    .right-nav {
        width: 300px;
        position: fixed;
        right: 0px;
        top: 50px;
        height: calc(100vh - 50px);
        background-color: rgba(67,76,90,0.8);
        .cross {
            position: absolute;
            right: 15px;
        }
        .group-btns {
            .group-btn-type {
                position: relative;
                color: white;
                text-align: center;
                p {
                    font-size: 13px;
                }
            }
            .btn {
                width: calc(100% - 20px);
                margin-top: 15px;
            }
            .cross {
                position: absolute;
                right: 20px;
                top: -4px;
                transform: scale(0.5);
            }
        }
        .arrow {
            margin-left: 15px;
            position: absolute;
            &.down { left: 30px; }
        }
        .field-title {
            color: white;
            text-align:center;
            font-weight: bold;
            margin: 5px;
        }
        .label {
            float: left;
            width: 90%;
            margin: 5px 5%;
            position: relative;
            > input { width: calc(100% - 10px); padding: 3px;font-size: 20px; }
            > select { width: calc(100% - 0px); }
            > p { color: white; font-size: 12px; text-transform: capitalize; }
            > textarea {
                width: calc(100% - 15px);
                min-width: calc(100% - 15px);
                max-width: calc(100% - 15px);
                min-height: 150px;
                padding: 3px;
                font-size: 20px;
            }
            &.color {
                input[type=color] { width: 22px; height: 32px; padding: 0px; border:0px; }
                input { width: calc(100% - 32px); float: left; }
            }
            &.w-50 {
                width: 40%;
                margin-left: 5%;
                margin-right: 2.5%;
            }
            &.w-btns-3 {
                .btn {
                    width: 80px;
                }
            }
            &.checkbox {
                margin-top: 0px;
                margin-left: 0px;
                width: 35px;
                margin-right: 0px;
                input { background-color: white; margin-left: 0px; }
                + .label {
                    margin: 0px;
                    width: 85px;
                }
            }
        }

    }
    .left-nav {
        width: 80px;
        height: calc(100% - 0px);
        background-color: rgba(67,76,90,0.8);
        overflow-y: scroll;
        position: relative;
        .type-box {
            padding-top: 10px;;
            border-bottom: 1px solid white;
            float: left;
            width: 100%;
            .type-icon {
                width: 29px;
                height: 29px;
                border: 1px solid white;
                margin: 0 auto;
                position: relative;
            }
            .type-title {
                margin: 3px 0px 3px 0px;
                color: white;
                font-size: 12px;
                text-align: center;
            }
        }
    }
    .view-box {
        position: fixed;
        width: calc(100% - 300px);
        height: calc(100vh - 92px);
        top: 92px;
        left: 0px;
        transition: all 0.3s;
        transform: scale(1);
        opacity: 1;
        z-index: 20;
        .fixed-scroller {
            .ad-img {
                border: 0px;
            }
        }
        .edit-card-box {
            header {
                border-bottom: 1px solid #c0c0c0;
                p { margin: 7.5px 0px 7.5px 5px; }
            }
            .assets-box {
                float:left;
                width: 100%;
                border:1px solid #c0c0c0;
                border-top: 0px;
                .label {
                    margin: 10px;float: left;width: calc(100% - 40px);
                    &.w-33 {
                        margin: 10px;float: left;width: calc(33% - 20px)
                    }
                    &.color {
                        input[type=color] { width: 22px; height: 32px; padding: 0px; border:0px; }
                        input { width: 90px; float: left; padding: 0px; font-size: 20px; padding: 2px; }
                    }
                }
                + .btns {
                    float: left;
                    width: 100%;
                    border:1px solid #c0c0c0;
                    border-top: 0px;
                }
            }
            &.edit-stamps.edit-headers {
                
                .stamp-box {
                    margin-top: 0px;
                    flex-wrap: wrap;
                    height: 250px;
                    margin-bottom: 35px;
                    margin-top: 20px;
                    > div {
                        width: 414px;
                        height: 76.6px;
                        position: relative;
                        p {
                            position: relative;
                            top: 0px;
                            text-align: center;
                            font-weight: bold;
                        }
                    }
                }
            }
            &.edit-stamps {

                .stamp-box,.stamp-title {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    width: 100%;
                }
                .stamp-box {
                    height: 110px;
                    margin-top: 40px;
                    > div {
                        width: 125px;
                        height: 125px;
                        > img {
                            width: 100%;
                        }
                    }
                }
                .stamp-title {
                    margin-top: 15px;
                    margin-bottom: 10px;
                    > p {
                        width: 100px;
                        text-align: center;
                    }
                }
            }
        }
        .v-alert.quill {

        }
        &.copy {
            transform: scale(0.6);
            opacity: 0;
        }
        .cards-box {
            float: left;
            width: 75%;
            left: 12.5%;
            display: flex;
            justify-content: space-around;
            overflow-y: scroll;
            overflow-x: scroll;
        }
        .card-container {
            width: 430px;
            border: 1px solid #c0c0c0;
            height: 532px;
            margin-top: 20px;
            background-color: white;
            &:last-child {
                margin-bottom: 100px;
            }
            .card-options {
                width: calc(100% - 12px);
                height: 20px;
                padding: 2px 6px;
                background-color: whitesmoke;
            }
            .edit-card-box {
                width: 414px;
                margin-left: 7px;
                height: 500px;
                margin-bottom: 5px;
                border: 0px;
                position: relative;
                box-shadow: #c0c0c0;
                .c-width,.cl-width,.cr-width {
                    width: 2px;
                    height: 100%;
                    background-color: red;
                    position: absolute;
                    left: calc(50% - 1px);
                    top: 0px;
                    &.cl-width {
                        left: calc(25% - 1px);
                    }
                    &.cr-width {
                        left: calc(75% - 1px);
                    }
                }
                
                .c-height {
                    width: 100%;
                    height: 2px;
                    background-color: red;
                    position: absolute;
                    left: 0px;
                    top: calc(50% - 1px);
                }
                &.selected { 
                    border: 2px solid green;
                    transform: translate(-2px,-2px)
                }
                .home-header-plain {
                    + .card-src {
                        top: 77px;
                        + .card-btns {
                            top: 77px;
                            height: calc(100% - 77px);
                        }
                    }

                    + .card-btns {
                        top: 77px;
                        height: calc(100% - 77px);
                    }
                }
                .card-src {
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    width: 100%;
                }
                .card-btns {
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    transform-origin: 0px;
                    width: 100%;
                    height: 100%;
                    .card-btn {
                        .ad-btn {
                            position: absolute;
                            background-color: rgba(200,0,0,0.2);  
                            &.selected {
                                
                                transform: translate(-2px,-2px);
                                border: 2px solid red;
                                border: 0px;
                                transform: translate(0px);
                                background-color: rgba(200,0,0,0.1);
                                /* z-index: 50; */
                            } 
                            > span {
                                float: left;
                            }                         
                        }
                        &.selected {
                            transform: translate(-1px,-1px);
                            border: 1px solid red;
                            background-color: rgba(200,0,0,0.6);
                            
                        }
                    }
                }            
            }
        }
    }
}
.font-box {
    position: fixed;
    top: 100px;
    left: 200px;
    height: calc(100% - 200px);
    overflow-y: scroll;
    transform: scale(1);
}    
</style>